/* Folliva hair analysis — engine. Content: fl-quiz-data.js, overridden by the texts set in Customize. v3 2026-10-06 (texts), 2026-10-07 (?start= ad links). */
(function () {
  'use strict';
  var D = window.FLQ_DATA;
  var root = document.querySelector('[data-flq-root]');
  if (!root || !D || root.__flq) return;
  root.__flq = true;

  var CFG = {};
  try { CFG = JSON.parse(root.querySelector('[data-flq-config]').textContent); } catch (e) {}
  /* texts changed in Customize (the quiz section's text blocks, snippets/fl-quiz-texts.liquid) replace the defaults
     in fl-quiz-data.js; only changed ones are sent, keyed by their place in the data ("plan.title", "questions.age.options.1.label") */
  (function applyTexts() {
    var el = root.querySelector('[data-flq-texts]'), t = {};
    try { t = JSON.parse((el && el.textContent) || '{}') || {}; } catch (e) { return; }
    Object.keys(t).forEach(function (path) {
      if (path === '_') return;
      var keys = path.split('.'), o = D;
      for (var i = 0; i < keys.length - 1; i++) { if (!o || typeof o !== 'object') return; o = o[keys[i]]; }
      if (o && typeof o === 'object') o[keys[keys.length - 1]] = t[path] == null ? '' : String(t[path]);
    });
  })();
  if (window.FLT && window.FLT.quiz_loading && D.loading) D.loading.title = window.FLT.quiz_loading;
  var stage = root.querySelector('[data-flq-stage]');
  var bar = root.querySelector('[data-flq-bar]');
  var backBtn = root.querySelector('[data-flq-back]');
  var afterEl = document.querySelector('[data-flq-after]');
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DEVICE = (window.matchMedia && matchMedia('(max-width: 749px)').matches) ? 'mobile' : 'desktop';
  var KEY = 'flq:v2';

  /* Public profile codes: neutral on purpose (URLs, cart attributes). */
  var CODES = { veteran: 'a1', dropout: 'a2', pillwary: 'a3', transplant: 'a4', minox: 'a5', gear: 'a6', natural: 'a7', trt: 'a8', notnow: 'a9' };
  var BY_CODE = {}; Object.keys(CODES).forEach(function (k) { BY_CODE[CODES[k]] = k; });
  /* ad link to a profile's own start screen (2026-10-07): ?start=a2 shows that profile's headline (intro.starts.a2) and its
     'Skip' link opens the profile's result page (?p=a2) instead of the product page. Without ?start the quiz is unchanged. */
  var START = (function () { var c = (new URLSearchParams(location.search).get('start') || '').toLowerCase(); return Object.prototype.hasOwnProperty.call(BY_CODE, c) ? c : ''; })();

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(s) { return esc(s).replace(/\[\[(.+?)\]\]/g, '<mark class="flq-hl">$1</mark>'); }
  function uid() { var a = new Uint8Array(12); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(a) : a.forEach(function (_, i) { a[i] = Math.random() * 256 | 0; }); return 'q' + Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  function joinAnd(list) { list = list.filter(Boolean); if (list.length < 2) return list.join(''); return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1]; }
  function lc1(s) { return /^I[ ']/.test(s) ? s : s.charAt(0).toLowerCase() + s.slice(1); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function has(arr, v) { return (arr || []).indexOf(v) > -1; }
  /* "{price} for {n} months" + { price: '€152,99', n: 3 } */
  function tpl(t, o) { return String(t == null ? '' : t).replace(/\{(\w+)\}/g, function (m0, k) { return o && Object.prototype.hasOwnProperty.call(o, k) ? o[k] : m0; }); }
  function opt(qid, v) { var q = D.questions[qid]; if (!q) return null; for (var i = 0; i < q.options.length; i++) if (q.options[i].v === v) return q.options[i]; return null; }
  function optLabel(qid, v) { var o = opt(qid, v); return o ? (o.sub && qid !== 'who' ? o.label + ': ' + o.sub.charAt(0).toLowerCase() + o.sub.slice(1) : o.label) : ''; }
  function arrow() { return '<svg class="flq-arr" viewBox="0 0 20 20" aria-hidden="true"><path d="M3 10h13m-5-5 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>'; }

  /* ---------- state ---------- */
  var s = load() || fresh();
  function fresh() {
    var q = new URLSearchParams(location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = q.get(k); if (v) utm[k] = v.slice(0, 150); });
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).host : ''; } catch (e) {}
    if (ref === location.host) ref = '';
    /* the "Not sure? See if it's right for you" link on the product page / landing adds ?from=pdp|landing */
    var from = (q.get('from') || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 20);
    if (from) ref = 'site:' + from;
    return { id: uid(), a: {}, step: 'intro', utm: utm, ref: ref, entry: START ? 'start_link' : 'quiz', t0: Date.now(), done: false, email: false };
  }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function load() {
    try {
      var x = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (x && x.id && Date.now() - (x.t0 || 0) < 3 * 3600 * 1000) return x;
    } catch (e) {}
    return null;
  }

  /* ---------- data out: Supabase (anonymous) + PostHog (only if loaded after consent) ---------- */
  function log(event, extra) {
    if (CFG.design_mode) return; /* theme editor previews never count as visits */
    extra = extra || {};
    var row = {
      quiz_id: s.id, event: event, entry: s.entry, device: DEVICE,
      referrer: s.ref || null, step: extra.step || null, profile: extra.profile || null,
      data: extra.data || null
    };
    for (var k in s.utm) row[k] = s.utm[k];
    if (CFG.sb_url && CFG.sb_key) {
      try {
        fetch(CFG.sb_url.replace(/\/$/, '') + '/rest/v1/quiz_events', {
          method: 'POST', keepalive: true,
          headers: { apikey: CFG.sb_key, Authorization: 'Bearer ' + CFG.sb_key, 'Content-Type': 'application/json', Prefer: 'return=minimal' },
          body: JSON.stringify(row)
        }).catch(function () {});
      } catch (e) {}
    }
    try {
      if (window.posthog && typeof posthog.capture === 'function') {
        posthog.capture('quiz_' + event, { step: row.step, profile: row.profile, entry: row.entry });
      }
    } catch (e) {}
  }

  /* ---------- where people leave and how long they stay (2026-10-09) ----------
     one anonymous 'leave' row each time the page is hidden or closed: seconds on the page and on the current step,
     how far down they scrolled and the deepest block they reached. No answers, nothing personal. Max 6 rows per page. */
  var LV = { t0: Date.now(), vis: 0, visT: document.visibilityState === 'visible' ? Date.now() : 0, stT: Date.now(), maxY: 0, sent: 0, hid: false }, lvRaf = 0;
  function lvScroll() { var y = (window.pageYOffset || 0) + window.innerHeight; if (y > LV.maxY) LV.maxY = y; }
  window.addEventListener('scroll', function () { if (!lvRaf) lvRaf = requestAnimationFrame(function () { lvRaf = 0; lvScroll(); }); }, { passive: true });
  function lvName(el) {
    var c = el.classList, id = el.id || '';
    if (id.indexOf('__') > -1) return 't:' + id.split('__').pop().slice(0, 20);
    if (c.contains('flq-pain')) return 'pain';
    if (c.contains('flq-hero')) return 'hero';
    if (c.contains('flq-trustlist')) return 'trust';
    if (c.contains('flq-how')) return 'how';
    if (c.contains('flq-band')) return 'band';
    if (c.contains('flq-faq')) return 'faq';
    if (el.querySelector('.flq-reason')) return 'reasons';
    if (el.querySelector('[data-flq-journey]')) return 'time';
    if (el.querySelector('.flq-stats')) return 'proof';
    if (el.querySelector('[class*="flq-mech"]')) return 'mech';
    return (el.tagName || '').toLowerCase() + '.' + (String(el.className || '').split(' ')[0] || '').slice(0, 20);
  }
  function lvMarks() {
    var els = [], sc = stage.firstChild, out = [], y0 = window.pageYOffset || 0, i;
    if (sc && sc.children) for (i = 0; i < sc.children.length; i++) els.push(sc.children[i]);
    if (afterEl) for (i = 0; i < afterEl.children.length; i++) els.push(afterEl.children[i]);
    if (s.step === 'offer') document.querySelectorAll('.shopify-section[id*="template--"]').forEach(function (x) { if (!x.contains(root)) els.push(x); });
    els.forEach(function (el) {
      if (!el.getBoundingClientRect || el.offsetHeight < 8) return;
      var cs = getComputedStyle(el); if (cs.position === 'fixed' || cs.display === 'none') return;
      out.push({ n: lvName(el), y: el.getBoundingClientRect().top + y0 });
    });
    return out.sort(function (a, b) { return a.y - b.y; });
  }
  function lvSend(why) {
    if (LV.sent >= 6) return;
    try {
      lvScroll();
      var now = Date.now(), vis = LV.vis + (LV.visT ? now - LV.visT : 0), marks = lvMarks(), deep = '', di = -1, lim = LV.maxY - window.innerHeight * 0.25, prof = null;
      for (var i = 0; i < marks.length; i++) if (marks[i].y <= lim) { deep = marks[i].n; di = i; }
      try { prof = s.direct ? P().code : (START || null); } catch (e) {}
      var H = Math.max(document.documentElement.scrollHeight, 1), d = {
        why: why, n: LV.sent + 1, secs: Math.round((now - LV.t0) / 1000), vis: Math.round(vis / 1000), st_secs: Math.round((now - LV.stT) / 1000),
        sc: Math.min(100, Math.round(LV.maxY / H * 100)), sec: deep, sec_i: di, sec_n: marks.length
      };
      if (s.step === 'plan') { d.plan = s.planSize || null; d.auto = s.planAuto !== false; }
      LV.sent++;
      log('leave', { step: s.step, profile: prof, data: d });
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (LV.visT) { LV.vis += Date.now() - LV.visT; LV.visT = 0; }
      if (!LV.hid) { LV.hid = true; lvSend('hide'); }
    } else { LV.visT = Date.now(); LV.hid = false; }
  });
  window.addEventListener('pagehide', function () { if (!LV.hid) { LV.hid = true; lvSend('close'); } });
  function lvMount() { try { LV.stT = Date.now(); LV.maxY = 0; lvScroll(); } catch (e) {} }

  /* ---------- flow ---------- */
  var ORDER = ['intro', 'where', 'when', 'amount', 'family', 'pattern', 'age', 'tried', 'fin', 'sides', 'whynot', 'situ', 'inter', 'worry', 'goal', 'expect', 'email', 'loading', 'reviews', 'reveal', 'mech', 'ready', 'offer', 'plan'];
  /* neutral codes in the address bar: step names like "sides" or "fin" never reach analytics URLs */
  function hcode(step) { s.hn = (s.hn || 0) + 1; var c = 'q' + s.hn; (s.hm || (s.hm = {}))[c] = step; return c; }
  function hstep(code) { return (code && s.hm && Object.prototype.hasOwnProperty.call(s.hm, code)) ? s.hm[code] : ''; }
  function optL(qid, v) { var o = opt(qid, v); return o ? o.label : '\u2014'; }
  var QSTEPS = ['where', 'when', 'amount', 'family', 'age', 'tried', 'fin', 'sides', 'whynot', 'situ', 'worry', 'goal', 'expect', 'email'];
  function triedFin(a) { return has(a.tried, 'fin_oral') || has(a.tried, 'dut') || has(a.tried, 'fin_top'); }
  function applies(step, a) {
    switch (step) {
      case 'when': case 'amount': return a.where && a.where !== 'none';
      case 'fin': return triedFin(a);
      case 'sides': return a.fin === 'sides';
      case 'whynot': return !triedFin(a);
      case 'proof': case 'mech': case 'ready': case 'hands': return profile(a).key !== 'notnow';
      case 'reviews': return !!(D.reviews && D.reviews.cases && D.reviews.cases.length && CFG.reviews && CFG.reviews.ba1);
      case 'plan': return false; /* reached only from the plan buttons */
      default: return true;
    }
  }
  function nextStep(from) {
    var i = ORDER.indexOf(from);
    for (var j = i + 1; j < ORDER.length; j++) if (applies(ORDER[j], s.a)) return ORDER[j];
    return 'offer';
  }

  /* ---------- profile rules (same priority as the avatar research codebook) ---------- */
  function profile(a) {
    if (s && s.entry === 'profile_link' && s.direct && D.profiles[s.direct]) return { key: s.direct };
    var tried = a.tried || [], situ = a.situ || [], fin = triedFin(a);
    if (has(situ, 'aas')) return { key: 'gear' };
    if (has(situ, 'trt')) return { key: 'trt' };
    if (a.fin === 'sides') return { key: 'dropout' };
    if (has(situ, 'baby')) return { key: 'notnow' };
    if (has(situ, 'ht_done') || has(situ, 'ht_plan')) return { key: 'transplant' };
    if (a.fin === 'feared') return { key: 'pillwary', variant: 'feared' };
    if (a.whynot === 'sides_fear') return { key: 'pillwary', variant: 'fear' };
    if (a.whynot === 'lifelong') return { key: 'pillwary', variant: 'lifelong' };
    if (a.fin === 'stacker') return { key: 'veteran', variant: 'stacker' };
    if (a.fin === 'nonresp') return { key: 'veteran', variant: 'nonresp' };
    if (has(tried, 'minox') && !fin) return { key: 'minox' };
    if (!fin && (a.whynot === 'natural' || has(tried, 'natural') || has(tried, 'supp'))) return { key: 'natural' };
    if (a.whynot === 'access' || a.fin === 'other') return { key: 'pillwary', variant: 'access' };
    if (a.where === 'none') return { key: 'pillwary', variant: 'early' };
    return { key: 'pillwary', variant: 'unaware' };
  }
  function P(pr) {
    pr = pr || profile(s.a);
    var base = D.profiles[pr.key] || D.profiles.pillwary;
    var out = {}; for (var k in base) out[k] = base[k];
    var v = pr.variant && base.variants && base.variants[pr.variant];
    if (v) {
      ['name', 'tag', 'gap', 'inter'].forEach(function (k) { if (v[k]) out[k] = v[k]; });
      if (v.proofTitle) out.proof = Object.assign({}, base.proof, { title: v.proofTitle });
      if (v.offerH) out.offer = Object.assign({}, base.offer, { h: v.offerH });
    }
    out.key = pr.key; out.variant = pr.variant || ''; out.code = CODES[pr.key];
    return out;
  }

  /* ---------- derived text ---------- */
  function stageIdx(a) {
    if (!a.where || a.where === 'none') return 0;
    var amt = { little: 1, some: 2, lot: 3 }[a.amount] || 1;
    var area = { temples: 1, crown: 1, both: 2, diffuse: 2 }[a.where] || 1;
    var dur = { months: 0, year: 1, y1_3: 2, y3p: 3 }[a.when] || 0;
    var sc = amt * 2 + area + (dur >= 2 ? 1 : 0);
    return sc <= 4 ? 1 : sc <= 6 ? 2 : 3;
  }
  function patternLabel(a) { return a.where === 'none' || !a.where ? D.labels.noLoss : D.pattern.area[a.where]; }
  function driverLabel(a, key) {
    var L = D.labels;
    if (key === 'gear') return L.driverAas;
    if (key === 'trt') return L.driverTrt;
    if (a.where === 'diffuse' && a.when === 'months') return L.driverCheck;
    return a.family && a.family !== 'no' ? L.driverInherited : L.driverPattern;
  }
  var FIN_SHORT = D.short.fin;
  var WHYNOT_SHORT = { sides_fear: 'Held back by: fear of sexual side effects', lifelong: 'Held back by: not wanting a lifelong pill', access: 'Held back by: no prescription', natural: 'Prefers natural options', unaware: "Didn't know finasteride was an option" };
  if (window.FLT && window.FLT.whynot) { for (var _k in window.FLT.whynot) { if (window.FLT.whynot[_k]) WHYNOT_SHORT[_k] = window.FLT.whynot[_k]; } }
  var SITU_SHORT = D.short.situ;
  function drugName(a) { var d = D.mirror.drug; return has(a.tried, 'fin_oral') ? d.fin_oral : has(a.tried, 'dut') ? d.dut : has(a.tried, 'fin_top') ? d.fin_top : d.fin_oral; }
  function otherTried(a) {
    var m = D.mirror.other;
    return (a.tried || []).filter(function (v) { return m[v]; }).map(function (v) { return m[v]; });
  }
  /* the sentence on the report screen, built from the answers; every piece is a text in Customize ("Report sentence") */
  function mirror(a, pr) {
    var M = D.mirror, S = [];
    if (a.where && a.where !== 'none') {
      var W = (a.where === 'temples' || a.where === 'both') ? M.whenMany : M.whenOne;
      /* the space before "all over" is added here: the theme editor trims spaces at the ends of a text when it saves */
      var v = tpl(W[a.when] || W.now, { all: a.where === 'diffuse' && M.allOver ? ' ' + String(M.allOver).trim() : '' });
      var fam = M.fam[a.family];
      S.push(M.subj[a.where] + ' ' + v + (fam ? ', ' + fam : '') + '.');
    } else {
      S.push(a.family && a.family !== 'no' ? M.noneFam : M.noneNo);
    }
    var k = pr.key, vr = pr.variant;
    if (k === 'dropout') {
      var list = (a.sides || []).filter(function (x) { return M.sides[x]; }).map(function (x) { return M.sides[x]; });
      S.push(tpl(M.dropout, { drug: drugName(a), list: list.length ? joinAnd(list) : M.sidesNone }));
    } else if (k === 'veteran') {
      var meds = (a.tried || []).filter(function (x) { return M.meds[x]; }).map(function (x) { return M.meds[x]; });
      S.push(vr === 'stacker' ? tpl(M.stacker, { drug: drugName(a) }) : tpl(M.veteran, { meds: joinAnd(meds) || M.medsNone }));
    } else if (k === 'pillwary') {
      var t = Object.prototype.hasOwnProperty.call(M.pillwary, vr) ? M.pillwary[vr] : '';
      if (t) S.push(t);
      var ot = otherTried(a); if (ot.length) S.push(tpl(M.tried, { list: joinAnd(ot) }));
    } else if (k === 'transplant') {
      S.push(has(a.situ, 'ht_done') ? M.transplantDone : M.transplantPlan);
    } else if (k === 'minox') {
      S.push(has(a.tried, 'natural') || has(a.tried, 'supp') ? M.minoxPlus : M.minoxOnly);
    } else if (k === 'gear') {
      S.push(tpl(M.gear, { fin: a.fin === 'nonresp' || a.fin === 'stacker' ? tpl(M.gearFin, { drug: drugName(a).toLowerCase() }) : '' }));
    } else if (k === 'trt') {
      S.push(tpl(M.trt, { extra: a.fin === 'sides' ? M.trtSides : a.whynot === 'sides_fear' ? M.trtFear : '' }));
    } else if (k === 'natural') {
      S.push(has(a.tried, 'natural') || has(a.tried, 'supp') ? M.naturalTried : M.naturalPref);
    } else if (k === 'notnow') {
      S.push(M.notnow);
    }
    var w = M.worry[a.worry];
    if (w) S.push(tpl(M.worryLine, { w: w }));
    return S.filter(Boolean).join(' ');
  }

  /* ---------- motion ---------- */
  function splitWords(el, start, step) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var sp = document.createElement('span');
            /* punctuation stays inline so it can't wrap onto its own line after a highlight */
            sp.className = /^[.,;:!?…)\]"”’»]+$/.test(p) ? 'flq-w flq-w--p' : 'flq-w';
            sp.style.setProperty('--d', (start + i * step) + 'ms'); sp.textContent = p;
            frag.appendChild(sp); i++;
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.tagName !== 'svg') {
          walk(ch);
          if (ch.tagName === 'MARK') ch.style.setProperty('--d', (start + i * step + 160) + 'ms');
        }
      });
    })(el);
    return start + i * step;
  }
  function animateText(sc) {
    if (!sc || REDUCED) return;
    /* slower, word by word, rising from below (closer to hims) */
    var t = 200;
    sc.querySelectorAll('.flq-big, .flq-lead--hl').forEach(function (el) { t = splitWords(el, t, el.classList.contains('flq-big') ? 78 : 40) + 160; });
    sc.querySelectorAll('.flq-mirror').forEach(function (el) { splitWords(el, 320, 30); });
    sc.querySelectorAll('.flq-voice').forEach(function (el) { splitWords(el, 600, 34); });
    ['.flq-opt', '.flq-tile', '.flq-stat', '.flq-pin', '.flq-reason', '.flq-fact', '.flq-chip', '.flq-report__row', '.flq-steps li', '.flq-journey li', '.flq-trust span', '.flq-meter__s', '.flq-points li', '.flq-rv', '.flq-trustlist li'].forEach(function (sel) {
      sc.querySelectorAll(sel).forEach(function (el, i) { el.style.setProperty('--i', i); });
    });
  }
  function countUp(sc) {
    if (REDUCED) return;
    sc.querySelectorAll('.flq-stat__n').forEach(function (el) {
      var m = /^([^0-9]*)([0-9]+)([^0-9]*)$/.exec(el.textContent.trim());
      if (!m) return;
      var n = parseInt(m[2], 10);
      if (n >= 1900 && n <= 2100) return; /* a year: leave it */
      var t0 = null, dur = 900;
      function f(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); k = 1 - Math.pow(1 - k, 3); el.textContent = m[1] + Math.round(n * k) + m[3]; if (k < 1) requestAnimationFrame(f); }
      el.textContent = m[1] + '0' + m[3];
      setTimeout(function () { requestAnimationFrame(f); }, 250);
    });
  }

  /* ---------- rendering ---------- */
  function setProgress(step) {
    var list = QSTEPS.filter(function (x) { return applies(x, s.a); });
    var i = list.indexOf(step);
    var pct = step === 'intro' ? 0 : i > -1 ? Math.round((i + 1) / (list.length + 1) * 100) : (ORDER.indexOf(step) > ORDER.indexOf('email') ? 100 : null);
    if (pct != null && bar) bar.style.width = pct + '%';
    root.classList.toggle('flq--story', ORDER.indexOf(step) > ORDER.indexOf('email'));
    if (backBtn) backBtn.hidden = step === 'loading';
  }

  var hist = [];
  function go(step, opts) {
    opts = opts || {};
    if (busy && !opts.force) return;
    if (step !== 'end' && ORDER.indexOf(step) === -1) step = 'intro';
    s.step = step;
    if (!opts.noPush) {
      try { history.pushState({ flq: step, sid: s.id }, '', step === 'intro' ? location.pathname + location.search : '#' + hcode(step)); } catch (e) {}
    }
    save();
    render(step, opts);
  }
  var busy = false;
  function render(step, opts) {
    opts = opts || {};
    var old = stage.firstChild;
    if (old && old.classList && old.classList.contains('flq-screen') && !REDUCED && !opts.instant) {
      busy = true;
      old.classList.remove('is-in');
      old.classList.add('is-out');
      if (opts.back) old.classList.add('is-out--back');
      if (footEl) footEl.classList.add('is-out');
      setTimeout(function () { busy = false; mount(step, opts); }, 190);
    } else {
      mount(step, opts);
    }
  }
  /* desktop: every step must fit the window without scrolling. Layout does most of it (CSS);
     if a screen is still taller than the window, scale it down a little (CSS zoom). */
  var DESK = window.matchMedia ? matchMedia('(min-width: 900px)') : null, FIT_MIN = 0.7;
  function fit() {
    var sc = stage.firstChild;
    if (!sc || !sc.classList || !sc.classList.contains('flq-screen')) return;
    sc.style.zoom = '';
    if (!DESK || !DESK.matches || s.step === 'offer') return;
    var over = fitOver();
    if (over <= 0) return;
    var h = sc.getBoundingClientRect().height || 1;
    var z = Math.floor(Math.max(FIT_MIN, Math.min(1, (h - over - 2) / h)) * 100) / 100;
    sc.style.zoom = z;
    for (var k = 0; k < 10 && fitOver() > 0 && z > FIT_MIN; k++) { z = Math.max(FIT_MIN, Math.round((z - 0.02) * 100) / 100); sc.style.zoom = z; }
  }
  /* how far the quiz itself runs past the bottom of the window. Only the quiz's own blocks count — anything a
     browser or extension adds to the page below the quiz (Opera did) must not shrink the quiz. */
  function fitOver() {
    var b = 0;
    for (var c = root.firstElementChild; c; c = c.nextElementSibling) {
      var cs = getComputedStyle(c);
      if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') continue;
      b = Math.max(b, c.getBoundingClientRect().bottom + window.pageYOffset);
    }
    return Math.ceil(b + (parseFloat(getComputedStyle(root).paddingBottom) || 0) - window.innerHeight);
  }
  var fitT;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(function () { fit(); moreTick(); }, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); });

  /* phones: on the question screens the page itself never scrolls (so the browser's toolbars never slide and
     nothing jitters); only the step content scrolls inside the stage, above a pinned button ("shell" mode).
     Intro, email and the offer page keep normal page scrolling. */
  var SHELL_OFF = ['intro', 'email', 'offer'];
  function shellOn() { return root.classList.contains('is-shell') && !(DESK && DESK.matches); }
  /* soft fade at the bottom while there is more below (like hims) */
  var moreEl = null;
  function moreTick() {
    if (!moreEl) return;
    var d = document.documentElement, sc = stage.firstChild;
    var left = shellOn() ? stage.scrollHeight - stage.scrollTop - stage.clientHeight : d.scrollHeight - (window.pageYOffset + window.innerHeight);
    var on = s.step !== 'offer' && s.step !== 'intro' && !!(sc && sc.classList && sc.classList.contains('is-in')) && left > 14;
    moreEl.classList.toggle('is-on', on);
    root.classList.toggle('is-more', on);
  }
  (function setupMore() {
    moreEl = document.createElement('div');
    moreEl.className = 'flq-fadebot'; moreEl.setAttribute('aria-hidden', 'true');
    root.appendChild(moreEl);
    var raf = 0, tick = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; moreTick(); }); };
    window.addEventListener('scroll', tick, { passive: true });
    stage.addEventListener('scroll', tick, { passive: true });
  })();

  var MOMENTS = ['pattern', 'inter', 'ready'];
  /* Folliva Clear: no logo/line where hims shows none; compact right-hand buttons; inline buttons on short screens */
  var BARE = ['pattern', 'inter', 'loading', 'recap', 'reviews', 'ready'];
  var INLINE = ['pattern', 'inter', 'ready'];
  var COMPACT = ['pattern', 'inter', 'ready', 'recap', 'reviews', 'reveal', 'mech', 'proof', 'hands'];
  var footEl = null;
  (function setupFoot() { footEl = document.createElement('div'); footEl.className = 'flq-foot'; root.appendChild(footEl); })();
  function placeActions(step) {
    if (!footEl) return;
    footEl.innerHTML = ''; footEl.classList.remove('is-out');
    root.classList.remove('has-foot');
    if (!shellOn() || INLINE.indexOf(step) > -1) return;
    var sc = stage.firstChild; if (!sc) return;
    var act = sc.querySelector('.flq-actions');
    if (!act || (act.closest && act.closest('form'))) return;
    footEl.appendChild(act);
    root.classList.add('has-foot');
  }
  function mount(step, opts) {
    setProgress(step);
    document.body.classList.toggle('flq-tail-on', step === 'offer' && P().key !== 'notnow');
    stage.setAttribute('data-step', step);
    root.classList.toggle('is-moment', MOMENTS.indexOf(step) > -1);
    root.classList.toggle('is-intro', step === 'intro');
    root.classList.toggle('is-bare', BARE.indexOf(step) > -1);
    root.classList.toggle('act-compact', COMPACT.indexOf(step) > -1);
    root.classList.toggle('act-inline', INLINE.indexOf(step) > -1);
    if (footEl) { footEl.innerHTML = ''; footEl.classList.remove('is-out'); root.classList.remove('has-foot'); }
    setShell(step);
    var html = '';
    glossUsed = {};
    try { html = build(step); } catch (err) {
      s = fresh(); save(); step = 'intro'; html = vIntro();
      stage.setAttribute('data-step', step); setProgress(step); document.body.classList.remove('flq-tail-on'); root.classList.remove('is-moment'); root.classList.add('is-intro'); setShell(step);
    }
    stage.innerHTML = '<div class="flq-screen flq-screen--' + step + (opts.back ? ' is-back' : '') + '">' + html + '</div>';
    after(step, opts);
  }
  function setShell(step) {
    var on = SHELL_OFF.indexOf(step) < 0;
    root.classList.toggle('is-shell', on);
    document.documentElement.classList.toggle('flq-shell', on);
  }
  function build(step) {
    var html = '';
    if (step === 'intro') { html = vIntro(); if (!s.introSeen) { s.introSeen = true; save(); log('intro_view', { step: 'intro', profile: START || null }); } }
    else if (D.questions[step]) html = vQuestion(step);
    else if (step === 'pattern') html = vPattern();
    else if (step === 'inter') html = vInter();
    else if (step === 'loading') html = vLoading();
    else if (step === 'recap') html = vRecap();
    else if (step === 'reviews') html = vReviews();
    else if (step === 'hands') html = vHands();
    else if (step === 'plan') { html = vPlan(); var pc = P().code; if (s.planLogged !== pc) { s.planLogged = pc; save(); log('plan_view', { step: 'plan', profile: pc }); } } /* 'Start my plan' opened the plan screen (2026-10-07) */
    else if (step === 'reveal') html = vReveal();
    else if (step === 'mech') html = vMech(P(), false);
    else if (step === 'proof') html = vProof(P(), false);
    else if (step === 'ready') html = vReady();
    else if (step === 'offer') html = vOffer();
    else if (step === 'end') html = vEnd(s.endKind || 'woman');
    return html;
  }
  function after(step, opts) {
    lvMount();
    stage.classList.toggle('is-grid', !!stage.querySelector('.flq-opts--grid'));
    root.classList.toggle('has-act', !!stage.querySelector('.flq-actions'));
    animateText(stage.firstChild);
    if (!opts.keepScroll) {
      try { window.scrollTo({ top: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, 0); }
      stage.scrollTop = 0;
    }
    bind(step);
    placeActions(step);
    if (step === 'offer') afterOffer();
    else if (afterEl) afterEl.innerHTML = '';
    fit();
    stage.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', fit, { once: true }); });
    var sc0 = stage.firstChild;
    if (moreEl) moreEl.classList.remove('is-on');
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (sc0) { sc0.classList.add('is-in'); countUp(sc0); moreTick(); setTimeout(moreTick, 700); } }); });
    var h = stage.querySelector('h1,h2'); if (h && !opts.noFocus) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
  }

  function actions(inner) { return '<div class="flq-actions">' + inner + '</div>'; }
  function btn(label, attr, cls) { return '<button type="button" class="flq-btn ' + (cls || '') + '" ' + (attr || '') + '><span>' + esc(label) + '</span>' + arrow() + '</button>'; }

  /* icons (inline, stroke) */
  var ICONS = {
    me: '<circle cx="12" cy="8" r="3.6"/><path d="M4.5 20c.8-4 3.8-6 7.5-6s6.7 2 7.5 6"/>',
    proxy: '<circle cx="9" cy="8.5" r="3.1"/><path d="M3.5 19.5c.6-3.4 2.8-5.2 5.5-5.2s4.9 1.8 5.5 5.2"/><circle cx="16.5" cy="7.5" r="2.5"/><path d="M15.2 13.2c2.7-.3 4.8 1.3 5.3 4.6"/>',
    pill: '<rect x="3.5" y="8.5" width="17" height="7" rx="3.5" transform="rotate(-35 12 12)"/><path d="M4 4l16 16"/>',
    shield: '<path d="M12 3l7 3v5.5c0 4.4-3 7.9-7 9.5-4-1.6-7-5.1-7-9.5V6z"/><path d="M8.8 12.2l2.2 2.2 4.4-4.6"/>',
    spray: '<rect x="7" y="9" width="8" height="12" rx="2"/><path d="M9 9V6h4v3M13 6h3M18 4.5l2-1M18 7h2.5M18 9.5l2 1"/>',
    calendar: '<rect x="3.5" y="5" width="17" height="15" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
    target: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/>',
    layers: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
    leaf: '<path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14z"/><path d="M5 19c3-4 6-7 10-9"/>',
    truck: '<path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17.5" cy="17.5" r="1.7"/>',
    pause: '<circle cx="12" cy="12" r="8.5"/><path d="M10 9v6M14 9v6"/>',
    flask: '<path d="M9.5 3h5M10.5 3v6L5 19a1.5 1.5 0 001.3 2h11.4a1.5 1.5 0 001.3-2L13.5 9V3"/><path d="M7.5 15h9"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    dot: '<circle cx="12" cy="12" r="3.2"/>',
    moon: '<path d="M19.5 14.5A8 8 0 019.5 4.5 8 8 0 1019.5 14.5z"/>',
    camera: '<rect x="3" y="7" width="18" height="13" rx="2.5"/><path d="M8.5 7l1.5-2.5h4L15.5 7"/><circle cx="12" cy="13.5" r="3.5"/>',
    drop: '<path d="M12 3.5c3.5 4.4 6 7.7 6 10.8a6 6 0 01-12 0c0-3.1 2.5-6.4 6-10.8z"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    doc: '<path d="M7 3.5h7l4 4V20a.5.5 0 01-.5.5h-10A.5.5 0 017 20z"/><path d="M14 3.5V8h4M9.5 12.5h5M9.5 16h5"/>',
    mailx: '<rect x="3.5" y="6" width="17" height="12" rx="2"/><path d="M4 7l8 6 8-6M4 4l16 16"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2.5"/><path d="M8.5 10.5V8a3.5 3.5 0 017 0v2.5"/>'
  };
  function ic(name, cls) { return '<svg class="flq-ic ' + (cls || '') + '" viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[name] || ICONS.dot) + '</svg>'; }
  var REASON_ICONS = { veteran: ['layers', 'flask', 'camera'], dropout: ['pill', 'shield', 'pause'], pillwary: ['pill', 'shield', 'pause'], transplant: ['shield', 'pill', 'target'], minox: ['layers', 'moon', 'shield'], gear: ['target', 'calendar', 'spray'], natural: ['flask', 'pill', 'spray'], trt: ['shield', 'target', 'layers'] };
  /* Shopify photos come in several widths (srcset), so a phone gets a phone-sized file, not the 1400 px original */
  function cdnW(u, w) { var b = String(u).replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, ''); return b + (b.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function img(u, cls, alt, eager, sizes) {
    if (!u) return '';
    var ss = /\/cdn\/shop\/|cdn\.shopify\.com/.test(u) ? [400, 600, 800, 1100].map(function (w) { return cdnW(u, w) + ' ' + w + 'w'; }).join(', ') : '';
    return '<img class="' + (cls || '') + '" src="' + esc(ss ? cdnW(u, 800) : u) + '"' + (ss ? ' srcset="' + esc(ss) + '" sizes="' + esc(sizes || '(min-width: 900px) 40vw, 90vw') + '"' : '') + ' alt="' + esc(alt || '') + '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async">';
  }
  function I(k) { return (CFG.images && CFG.images[k]) || ''; }
  function F(k, fb) { return (CFG.fc && CFG.fc[k]) || (fb ? I(fb) : ''); } /* new Folliva Clear photos (theme assets) */
  function heads(k) { return (CFG.images && CFG.images.heads && CFG.images.heads[k]) || ''; }

  /* intro */
  function vIntro() {
    var In = D.intro;
    /* photos drift in three slow columns, each tile on its own (never boxed together) */
    var pics = [F('portrait_27', 'intro_2'), F('mist', 'ready_2'), F('portrait_45', 'intro_main'), F('plinth_wide', 'ready_1'), F('gym', 'ready_3'), I('intro_main')].filter(Boolean), cols = '';
    if (pics.length >= 3) {
      var n = pics.length, sets = [[pics[0], pics[3 % n]], [pics[1], pics[4 % n]], [pics[2], pics[5 % n]]];
      cols = '<div class="flq-drift" aria-hidden="true">' + sets.map(function (col, i) {
        var tiles = col.concat(col).map(function (u) { return '<figure class="flq-drift__t">' + img(u, '', '', true, '(min-width: 900px) 360px, 36vw') + '</figure>'; }).join('');
        return '<div class="flq-drift__c flq-drift__c--' + (i + 1) + '"><div class="flq-drift__track">' + tiles + '</div></div>';
      }).join('') + '</div>';
    }
    var su = CFG.skip_url || '/', qs = location.search.replace(/^\?/, '');
    if (START) { su = location.pathname + '?p=' + START; qs = qs.split('&').filter(function (kv) { var k = kv.split('=')[0]; return kv && k !== 'start' && k !== 'p'; }).join('&'); }
    var title = (START && In.starts && In.starts[START]) || In.title;
    var skipUrl = esc(su + (qs ? (su.indexOf('?') > -1 ? '&' : '?') + qs : ''));
    var pts = (In.points || []).map(function (t, i) { return !t ? '' : '<li style="--i:' + i + '">' + ic(['clock', 'doc', 'mailx'][i] || 'check') + '<span>' + esc(t) + '</span></li>'; }).join('');
    return '<div class="flq-intro flq-intro--a">' + cols + '<div class="flq-intro__txt">' +
      '<h1 class="flq-title flq-title--xl">' + hl(title) + '</h1>' +
      (pts ? '<ul class="flq-points">' + pts + '</ul>' : '') +
      '<div class="flq-actions flq-actions--intro">' + (In.skip ? '<a href="' + skipUrl + '" class="flq-link flq-skiplink" data-flq-skiplink>' + esc(In.skip) + '</a>' : '') + btn(In.cta, 'data-flq-start', 'flq-btn--go') + '</div>' +
      social() + (In.proxy ? '<p class="flq-fine flq-proxylink"><button type="button" class="flq-link" data-flq-proxy>' + esc(In.proxy) + '</button></p>' : '') + (In.note ? '<p class="flq-fine flq-anon">' + ic('shield', 'flq-ic--sm') + '<span>' + esc(In.note) + '</span></p>' : '') + '</div></div>';
  }
  function social() {
    if (!CFG.social || (!CFG.social.pill && !CFG.social.line)) return '';
    var av = (CFG.social.avatars || []).map(function (u) { return '<img src="' + esc(u) + '" alt="" width="40" height="40" loading="eager">'; }).join('');
    var stars = CFG.social.stars ? '<span class="flq-stars" aria-hidden="true">★★★★★</span>' : '';
    return '<div class="flq-social">' + (av ? '<span class="flq-social__av">' + av + '</span>' : '') +
      '<span class="flq-social__txt">' + stars + (CFG.social.pill ? '<span>' + CFG.social.pill + '</span>' : '') + '</span></div>';
  }

  /* questions */
  function optIcon(q, o) {
    if (o.icon === 'me' || o.icon === 'proxy') return '<span class="flq-opt__ic flq-opt__ic--sm">' + ic(o.icon) + '</span>';
    if (!q.icons) return '';
    var u = heads(o.icon);
    return '<span class="flq-opt__ic">' + (u ? img(u, '', '', true) : headIcon(o.icon)) + '</span>';
  }
  function visibleOpts(id) {
    var q = D.questions[id], pr = (id === 'worry' || id === 'goal') ? profile(s.a).key : null;
    return (q.options || []).filter(function (o) { return !o.only || o.only === pr; });
  }
  function vQuestion(id) {
    var q = D.questions[id], a = s.a, pr = (id === 'worry' || id === 'goal') ? profile(a).key : null;
    var title = (s.a.who === 'proxy' && q.titleProxy) ? q.titleProxy : q.title;
    var head = (s.a.who === 'proxy' && id !== 'who' ? '<p class="flq-proxy">' + ic('proxy', 'flq-ic--sm') + esc(D.proxyNote) + '</p>' : '') +
      '<h1 class="flq-title">' + hl(title) + '</h1>' + (q.sub ? '<p class="flq-sub">' + esc(q.sub) + '</p>' : '');
    var why = q.why ? '<aside class="flq-why"><p class="flq-why__h">' + ic('dot', 'flq-ic--xs') + esc(q.whyH || D.labels.whyAsk) + '</p><p>' + esc(q.why) + '</p></aside>' : '';
    if (q.type === 'email') {
      var priv = '<a href="' + esc(CFG.privacy_url || '/policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(q.privacy) + '</a>';
      return head + '<form class="flq-email" data-flq-email novalidate>' +
        '<label class="flq-field"><span class="flq-vh">Email</span><input type="email" name="email" autocomplete="email" inputmode="email" placeholder="' + esc(q.placeholder) + '" required></label>' +
        '<label class="flq-check"><input type="checkbox" name="consent" required><span class="flq-check__box" aria-hidden="true"></span><span>' + esc(q.consent) + ' ' + priv + '</span></label>' +
        '<p class="flq-err" data-flq-err hidden></p>' +
        actions('<button type="submit" class="flq-btn"><span>' + esc(q.cta) + '</span>' + arrow() + '</button><button type="button" class="flq-link" data-flq-skip>' + esc(q.skip) + '</button>') +
        '</form>';
    }
    var multi = q.type === 'multi', cur = a[id];
    var opts = visibleOpts(id);
    var list = '<div class="flq-opts' + (q.icons ? ' flq-opts--icons' : '') + (multi && opts.length >= 6 ? ' flq-opts--grid' : '') + '" role="' + (multi ? 'group' : 'radiogroup') + '">' + opts.map(function (o, i) {
      var checked = multi ? has(cur, o.v) : cur === o.v;
      return '<label class="flq-opt' + (checked ? ' is-on' : '') + '">' +
        '<input type="' + (multi ? 'checkbox' : 'radio') + '" name="flq-q" value="' + i + '"' + (checked ? ' checked' : '') + (o.exclusive ? ' data-exclusive' : '') + '><span class="flq-opt__ring" aria-hidden="true"></span>' +
        optIcon(q, o) +
        '<span class="flq-opt__txt"><span class="flq-opt__l">' + esc(o.label) + '</span>' + (o.sub ? '<span class="flq-opt__s">' + esc(o.sub) + '</span>' : '') + '</span>' +
        (multi ? '<span class="flq-opt__box" aria-hidden="true">' + ic('check') + '</span>' : '<span class="flq-opt__go" aria-hidden="true">' + arrow() + '</span>') +
        '</label>';
    }).join('') + '</div>';
    return head + list + why + (multi ? actions(btn(D.labels.cont, 'data-flq-multi-next' + (cur && cur.length ? '' : ' disabled')) + '<p class="flq-actfine">' + esc(D.labels.quizFine || '') + '</p>') : '');
  }

  /* interstitial A */
  function vPattern() {
    var a = s.a, Pt = D.pattern, title, extra = '';
    if (!a.where || a.where === 'none') {
      title = Pt.noneTitle.replace('{fam}', a.family && a.family !== 'no' ? Pt.noneFam : '');
    } else {
      var bits = ['[[' + Pt.area[a.where] + ']]'];
      if (a.when) bits.push('[[' + Pt.when[a.when] + ']]');
      if (Pt.family[a.family]) bits.push('[[' + Pt.family[a.family] + ']]');
      title = bits.join(', ') + '. ' + Pt.named;
      extra = '<p class="flq-lead flq-lead--hl">' + hl(Pt.explain) + '</p>';
      if (a.where === 'diffuse' && a.when === 'months') extra += '<aside class="flq-why flq-why--warn"><p class="flq-why__h">' + esc(D.labels.worth) + '</p><p>' + esc(Pt.diffuseNew) + '</p></aside>';
    }
    /* same layout as the insight screen: no picture, the sentence carries it */
    return '<div class="flq-inter"><p class="flq-eyebrow">' + esc(Pt.eyebrow) + '</p><h2 class="flq-big">' + hl(title) + '</h2>' + extra + '</div>' + actions(btn(D.labels.next, 'data-flq-next'));
  }
  /* interstitial B */
  function vInter() {
    var p = P(), parts = String(p.inter).split(' || ');
    return '<div class="flq-inter"><p class="flq-eyebrow">' + esc(p.name) + '</p><h2 class="flq-big">' + hl(parts[0]) + '</h2>' +
      (parts[1] ? '<p class="flq-lead flq-lead--hl">' + gl(hl(parts[1])) + '</p>' : '') + '</div>' + actions(btn(D.labels.next, 'data-flq-next'));
  }

  /* loading */
  function vLoading() {
    var a = s.a, p = P(), L = D.loading;
    var triedTxt = (a.tried || []).filter(function (v) { return v !== 'nothing'; }).map(function (v) { return optL('tried', v); });
    var finTxt = a.fin ? ' · ' + FIN_SHORT[a.fin].toLowerCase() : '';
    var details = [patternLabel(a) + ' · ' + D.labels.stages[stageIdx(a)].toLowerCase(), (triedTxt.length ? triedTxt.slice(0, 3).join(', ') : D.labels.nothing) + finTxt, driverLabel(a, p.key), p.name];
    var pics = [I('ready_3'), I('ready_2'), I('ready_1')];
    var fl = '<div class="flq-lfl" aria-hidden="true">' + pics.map(function (u, i) { return u ? '<figure class="flq-lfl__t flq-lfl__t--' + (i + 1) + '">' + img(u, '', '', true) + '</figure>' : ''; }).join('') + '</div>';
    /* personal details are shown through CSS attr(data-t), so page-text readers (Meta's "ss" rule) never see them */
    return '<div class="flq-load flq-load--a">' + fl +
      '<h2 class="flq-lstat" tabindex="-1"><span class="flq-status" data-flq-status>' + esc(L.lines[0]) + '</span></h2>' +
      '<div class="flq-lrow"><div class="flq-lring"><svg class="flq-ring" viewBox="0 0 80 80" aria-hidden="true"><circle cx="40" cy="40" r="37"/><circle class="flq-ring__p" cx="40" cy="40" r="37"/></svg>' +
      '<span class="flq-pct"><span data-flq-pct>0</span>%</span><svg class="flq-lok" viewBox="0 0 80 80" aria-hidden="true"><path d="M27 41l9 9 18-19"/></svg></div>' +
      '<ul class="flq-load__list flq-lsteps">' + L.steps.map(function (t, i) { return '<li data-i="' + i + '"><strong>' + esc(t) + '</strong><em data-t="' + esc(details[i]) + '"></em></li>'; }).join('') + '</ul></div>' +
      '<p class="flq-vh">' + esc(L.title) + '</p></div>';
  }
  /* recap = hair report */
  function chip(text, kind) { return '<span class="flq-chip flq-chip--' + (kind || 'n') + '">' + (kind === 'ok' ? ic('check') : kind === 'stop' ? ic('x') : kind === 'warn' ? ic('dot') : '') + esc(text) + '</span>'; }
  function vRecap() {
    var a = s.a, R = D.recap, L = D.labels, si = stageIdx(a);
    var famTxt = a.family ? R.fam[a.family] : '—';
    var facts = [
      [L.pattern, patternLabel(a)], [R.k.noticed, a.when ? cap(D.pattern.when[a.when].replace(/^noticed |^going for /, '')) : '—'],
      [R.k.amount, a.amount ? optL('amount', a.amount) : '—'], [R.k.family, famTxt], [R.k.age, a.age ? optL('age', a.age) : '—']
    ];
    var tried = (a.tried || []).filter(function (v) { return v !== 'nothing'; }).map(function (v) {
      var lab = optL('tried', v);
      if ((v === 'fin_oral' || v === 'dut' || v === 'fin_top') && a.fin) lab += (a.fin === 'nonresp' || a.fin === 'stacker') ? R.k.onIt : R.k.stopped;
      return '<span>' + esc(lab) + '</span>';
    }).join(' ') || '<span>' + esc(L.nothing) + '</span>';
    var situ = (a.situ || []).filter(function (v) { return SITU_SHORT[v]; }).map(function (v) { return '<span>' + esc(SITU_SHORT[v]) + '</span>'; }).join(' ');
    var date = new Date().toLocaleDateString(((document.documentElement.lang || 'en').indexOf('de') === 0 ? 'de-DE' : 'en-GB'), { day: 'numeric', month: 'short', year: 'numeric' });
    var wg = (a.worry ? '<div><p class="flq-report__k">' + esc(R.k.worry) + '</p><p class="flq-report__v">' + esc(optL('worry', a.worry)) + '</p></div>' : '') +
      (a.goal ? '<div><p class="flq-report__k">' + esc(R.k.goal) + '</p><p class="flq-report__v">' + esc(optL('goal', a.goal)) + '</p></div>' : '');
    return '<h2 class="flq-title flq-title--say">' + esc(R.title) + '</h2>' +
      '<div class="flq-report flq-report--a"><div class="flq-report__top"><span class="flq-report__brand">' + esc(R.k.brand) + '</span><span class="flq-report__meta">' + esc(date) + ' · #' + esc(s.id.slice(1, 7).toUpperCase()) + '</span></div>' +
      '<section class="flq-sheet"><dl class="flq-facts">' + facts.map(function (f) { return '<div class="flq-fact"><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('') +
      '<div class="flq-fact flq-fact--stage"><dt>' + esc(L.stage) + '</dt><dd>' + esc(L.stages[si]) + '<span class="flq-mini">' + [0, 1, 2, 3].map(function (k) { return '<i class="' + (k <= si ? 'is-f' : '') + '"></i>'; }).join('') + '</span></dd></div></dl></section>' +
      '<section class="flq-sheet flq-report__row"><p class="flq-report__k">' + esc(R.groups.tried) + '</p><p class="flq-dots">' + tried + '</p>' +
      (situ ? '<p class="flq-report__k">' + esc(R.groups.situ) + '</p><p class="flq-dots flq-dots--acc">' + situ + '</p>' : '') + '</section>' +
      (wg ? '<section class="flq-sheet flq-report__row flq-sheet--two">' + wg + '</section>' : '') + '</div>' +
      '<div class="flq-recapfoot"><p class="flq-fade">' + esc(R.next) + '</p>' + actions(btn(D.labels.next, 'data-flq-next')) + '</div>';
  }

  /* customer results (right after the report) */
  function vReviews() {
    var R = D.reviews, ims = CFG.reviews || {};
    var cards = R.cases.map(function (c) {
      var u = ims[c.img], u2 = c.img2 ? ims[c.img2] : null;
      if (!u) return '';
      return '<article class="flq-rv"><figure class="flq-rv__img' + (u2 ? ' flq-rv__img--pair' : '') + '">' + img(u, '', u2 ? 'Before' : 'Before and after') + (u2 ? img(u2, '', 'After') : '') +
        '<span class="flq-rv__tag">' + esc(R.before) + '</span><span class="flq-rv__tag flq-rv__tag--r">' + esc(R.after) + '</span></figure>' +
        '<p class="flq-rv__stars" aria-label="5 out of 5">★★★★★</p><blockquote>“' + esc(c.quote) + '”</blockquote>' +
        '<div class="flq-rv__who"><span class="flq-rv__av" aria-hidden="true">' + esc(c.name.charAt(0)) + '</span><span><b>' + esc(c.name) + '</b><em>' + ic('shield', 'flq-ic--sm') + esc(R.badge) + '</em></span></div></article>';
    }).join('');
    return '<p class="flq-eyebrow">' + esc(R.label) + '</p><h2 class="flq-title">' + hl(R.title) + '</h2>' +
      '<div class="flq-rvs">' + cards + '</div><p class="flq-note">' + esc(R.note) + '</p>' + actions(btn(R.cta, 'data-flq-next'));
  }
  /* reveal */
  function meter(i) {
    var L = D.labels;
    return '<div class="flq-meter">' + L.stages.map(function (t, k) { return '<span class="flq-meter__s' + (k <= i ? ' is-f' : '') + (k === i ? ' is-you' : '') + '"><em>' + esc(t) + '</em></span>'; }).join('') + '</div>';
  }
  function tiles(a, p) {
    var L = D.labels;
    return '<div class="flq-tiles">' +
      '<div class="flq-tile">' + ic('target') + '<p class="flq-tile__k">' + esc(L.pattern) + '</p><p class="flq-tile__v">' + esc(patternLabel(a)) + '</p></div>' +
      '<div class="flq-tile">' + ic('flask') + '<p class="flq-tile__k">' + esc(L.driver) + '</p><p class="flq-tile__v">' + esc(driverLabel(a, p.key)) + '</p></div>' +
      '<div class="flq-tile flq-tile--gap">' + ic('layers') + '<p class="flq-tile__k">' + esc(L.gap) + '</p><p class="flq-tile__v">' + esc(p.gap) + '</p></div></div>';
  }
  function profileCard(p, small) {
    return '<div class="flq-pcard' + (small ? ' flq-pcard--sm' : '') + '"><span class="flq-pcard__glow" aria-hidden="true"></span><p class="flq-pcard__k">' + ic('target', 'flq-ic--sm') + esc(D.labels.profile) + '</p>' +
      '<h1 class="flq-pcard__name">' + esc(p.name) + '</h1><p class="flq-pcard__tag">' + esc(p.tag) + '</p></div>';
  }
  function call(h, t) { return '<div class="flq-call flq-tile"><h3>' + esc(h) + '</h3><p>' + esc(t) + '</p></div>'; }
  function vReveal() {
    var a = s.a, p = P(), L = D.labels, si = stageIdx(a);
    var rdate = new Date().toLocaleDateString(((document.documentElement.lang || 'en').indexOf('de') === 0 ? 'de-DE' : 'en-GB'), { day: 'numeric', month: 'short', year: 'numeric' });
    return '<p class="flq-eyebrow flq-reptag">' + esc(L.revealEyebrow || 'Your hair report') + ' · ' + esc(rdate) + ' · #' + esc(s.id.slice(1, 7).toUpperCase()) + '</p>' +
      '<h1 class="flq-title">' + esc(L.profile) + ': <mark class="flq-hl">' + esc(p.name) + '</mark>.</h1>' +
      '<p class="flq-sub">' + esc(p.tag) + '</p>' +
      '<div class="flq-rev flq-rev--a"><div class="flq-rev__l"><blockquote class="flq-mirror">' + esc(mirror(a, p)) + '</blockquote>' +
      '<div class="flq-card flq-stagecard"><div class="flq-stagecard__h"><p class="flq-tile__k">' + esc(L.stage) + '</p><p class="flq-stagecard__v">' + esc(L.stages[si]) + '</p></div>' + meter(si) + '<p class="flq-note">' + esc(L.stageNote) + '</p></div></div>' +
      '<div class="flq-rev__r"><div class="flq-calls">' + call(L.pattern, patternLabel(a)) + call(L.driver, driverLabel(a, p.key)) + call(L.gap, p.gap) + '</div>' + (L.urgency ? '<p class="flq-urgency">' + hl(L.urgency) + '</p>' : '') + '</div></div>' +
      actions(btn(L.revealCta || L.next, 'data-flq-next'));
  }
  /* mechanism */
  var TAG3D = { enzyme: [5, 7, 'Testosterone → DHT'], receptor: [57, 80, 'DHT receptor'], growth: [64, 42, 'Growth phase'], graft: [64, 60, 'Graft'], bypass: [54, 7, 'DHT-derived'] };
  Object.keys(TAG3D).forEach(function (k) { if (D.mech3d && D.mech3d[k] != null) TAG3D[k][2] = D.mech3d[k]; });
  var ROLE3D = { enzyme: 'source', bypass: 'source', receptor: 'receptor', growth: 'growth', graft: 'growth' };
  function vMechAnim(p, m, u, MA, layers, compact) {
    var dur = +MA.dur || 11, role = function (x) { return ROLE3D[x.at] || x.at; };
    var tags = m.pins.map(function (x, i) { var t = TAG3D[x.at] || [50, 50, '']; return '<button type="button" class="fcm__tag" data-fcm-pick data-fcm-role="' + role(x) + '" aria-pressed="false" style="left:' + t[0] + '%;top:' + t[1] + '%"><b>' + (i + 1) + '</b><span>' + esc(t[2]) + '</span></button>'; }).join('');
    var play = MA.play ? '<button type="button" class="fcm__play" data-fcm-replay><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 5.2v9.6l7.6-4.8z"/></svg><span>' + esc(MA.play) + '</span></button>' : '';
    var lg = (MA.legend || []).map(function (t, i) { return t ? '<li><i class="fcm__lg fcm__lg--' + ['t', 'd', 's'][i] + '"></i>' + esc(t) + '</li>' : ''; }).join('');
    var fig = '<div class="flq-mechfig"><figure class="fcm__fig flq-mech3d">' + img(u, 'fcm__img flq-mech3d__img', 'Hair follicle cross-section', true) + layers + tags + play + '</figure>' + (lg ? '<ul class="fcm__legend">' + lg + '</ul>' : '') + '</div>';
    var cards = '<div class="flq-mechcol">' + (MA.hint ? '<p class="flq-tap">' + esc(MA.hint) + '</p>' : '') +
      '<ol class="flq-pins">' + m.pins.map(function (x, i) { return '<li class="flq-pin flq-pin--' + x.tone + '" data-fcm-pick data-fcm-role="' + role(x) + '" tabindex="0"><span class="flq-pin__n">' + (i + 1) + '</span><span>' + ((TAG3D[x.at] || [])[2] ? '<span class="flq-pin__k">' + esc(TAG3D[x.at][2]) + '</span>' : '') + '<strong>' + esc(x.h) + '</strong>' + gl(esc(x.t)) + '</span></li>'; }).join('') + '</ol>' +
      '<p class="flq-mechcap">' + gl(esc(m.caption || D.labels.mechCaption)) + '</p></div>';
    var head = (compact ? '' : '<p class="flq-eyebrow">' + esc(D.labels.mechEyebrow) + '</p>') + '<h2 class="flq-title">' + hl(m.title) + '</h2>';
    return head + '<div class="flq-mechwrap fcm fcm--quiz" data-fcm data-auto="true" data-dur="' + dur + '" style="--fcm-dur:' + dur + 's">' + fig + cards + '</div>' + glossCard(p) + (compact ? '' : actions(btn(D.labels.next, 'data-flq-next')));
  }
  function vMech(p, compact) {
    var m = p.mech; if (!m) return '';
    var u = I('mech');
    var MA = CFG.mech || {}, lay = document.getElementById('flq-mech-layers');
    if (u && MA.anim && lay) return vMechAnim(p, m, u, MA, lay.innerHTML, compact);
    var ats = m.pins.map(function (x) { return x.at; });
    var parts = '';
    for (var k = 0; k < 9; k++) parts += '<i class="flq-dht flq-dht--' + k + '"></i>';
    var fig = u ? '<figure class="flq-mech3d" data-pins="' + ats.join(' ') + '">' + img(u, 'flq-mech3d__img', 'Hair follicle cross-section', true) +
      '<span class="flq-shield" aria-hidden="true"></span><span class="flq-cloud" aria-hidden="true">' + parts + '</span>' +
      m.pins.map(function (x, i) { var t = TAG3D[x.at] || [50, 50, '']; return '<button type="button" class="flq-tag3d flq-tag3d--' + x.tone + '" data-pin="' + i + '" style="left:' + t[0] + '%;top:' + t[1] + '%;--i:' + i + '"><b>' + (i + 1) + '</b>' + esc(t[2]) + '</button>'; }).join('') +
      '</figure>' : '<figure class="flq-mech">' + mechSVG(ats) + '</figure>';
    var cards = '<div class="flq-mechcol">' + (u ? '<p class="flq-tap">' + ic('target', 'flq-ic--sm') + esc(D.labels.mechTap) + '</p>' : '') +
      '<ol class="flq-pins">' + m.pins.map(function (x, i) { return '<li class="flq-pin flq-pin--' + x.tone + '" data-pin="' + i + '" tabindex="0"><span class="flq-pin__n">' + (i + 1) + '</span><span>' + ((TAG3D[x.at] || [])[2] ? '<span class="flq-pin__k">' + esc(TAG3D[x.at][2]) + '</span>' : '') + '<strong>' + esc(x.h) + '</strong>' + gl(esc(x.t)) + '</span></li>'; }).join('') + '</ol>' +
      '<p class="flq-mechcap">' + gl(esc(m.caption || D.labels.mechCaption)) + '</p></div>';
    var head = (compact ? '' : '<p class="flq-eyebrow">' + esc(D.labels.mechEyebrow) + '</p>') + '<h2 class="flq-title">' + hl(m.title) + '</h2>';
    return head + '<div class="flq-mechwrap">' + fig + cards + '</div>' + glossCard(p) + (compact ? '' : actions(btn(D.labels.next, 'data-flq-next')));
  }

  /* proof */
  function vProof(p, compact) {
    var pf = p.proof; if (!pf) return '';
    var cards = '<div class="flq-stats">' + pf.stats.map(function (x, i) { return '<div class="flq-stat"><span class="flq-orb" aria-hidden="true"></span><p class="flq-stat__n">' + esc(x.n) + '</p><p class="flq-stat__t">' + gl(esc(x.t)) + (x.src ? '<sup>' + (i + 1) + '</sup>' : '') + '</p></div>'; }).join('') + '</div>';
    var src = pf.stats.filter(function (x) { return x.src; }).map(function (x, i) { return '<li>' + (i + 1) + '. ' + esc(x.src) + '</li>'; }).join('');
    return (compact ? '' : '<p class="flq-eyebrow">' + esc(D.labels.proofEyebrow) + '</p>') + '<h2 class="flq-title">' + hl(pf.title) + '</h2>' + cards +
      (pf.voice ? '<p class="flq-voice">' + esc(pf.voice) + '</p>' : '') + (src ? '<ol class="flq-src">' + src + '</ol>' : '') + (compact ? '' : actions(btn(D.labels.next, 'data-flq-next')));
  }

  /* ready */
  /* why us, right before the plan */
  function vHands() {
    var H = D.hands;
    var pts = H.points.map(function (x) { return '<div class="flq-call flq-tile"><h3>' + esc(x.h) + '</h3><p>' + esc(x.t) + '</p></div>'; }).join('');
    var hp = F('temple', 'ready_2'), pic = hp ? '<figure class="flq-hands__img">' + img(hp, '', '', true) + '</figure>' : '';
    return '<div class="flq-hands"><div class="flq-hands__l"><p class="flq-eyebrow">' + esc(H.label) + '</p><h2 class="flq-title">' + hl(H.title) + '</h2><p class="flq-sub">' + esc(H.sub) + '</p>' + pic + '</div>' +
      '<div class="flq-hands__r"><div class="flq-calls">' + pts + '</div>' + social() + '</div></div>' + actions(btn(H.cta, 'data-flq-next'));
  }
  function vReady() {
    var R = D.ready, pics = [F('hand_sky', 'intro_2'), F('portrait_35', 'intro_main'), F('night', 'intro_3')].filter(Boolean);
    var col = pics.length ? '<div class="flq-float3">' + pics.map(function (u, i) { return '<figure class="flq-f3 flq-f3--' + (i + 1) + '">' + img(u, '', '', true) + '</figure>'; }).join('') + '</div>' : '';
    return col + '<h2 class="flq-big flq-big--c">' + esc(R.good || 'Good news.') + '</h2><p class="flq-sub flq-sub--c">' + esc(R.line || R.sub) + '</p>' +
      '<svg class="flq-okmark" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="29"/><path d="M20 33l8 8 16-17"/></svg>' + actions(btn(R.cta, 'data-flq-next'));
  }
  /* offer */
  function variantFor(size) { var v = (CFG.variants || []).filter(function (x) { return x.title === size; })[0]; return v || null; }
  function money(c) {
    var f = CFG.money_format || '€{{amount_with_comma_separator}}', v = (Math.max(0, c) / 100).toFixed(2);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m0, k) { return /comma/.test(k) ? v.replace('.', ',') : /no_decimals/.test(k) ? String(Math.round(c / 100)) : v; });
  }
  function money0(c) { var m = money(Math.round(c / 100) * 100); return m.replace(/[.,]00(?!\d)/, ''); }
  function perMonth(v, auto) { var each = auto && v.sub_c ? v.sub_c : v.price_c; return money(Math.floor(each / (v.months || 1))); }
  /* the 90-day guarantee under every buy button: [[bold part]] rest */
  function guarLine(t) { return t ? '<p class="flq-guarline">' + ic('shield', 'flq-ic--sm') + '<span>' + esc(t).replace(/\[\[(.+?)\]\]/g, '<strong>$1</strong>') + '</span></p>' : ''; }
  function planCard(p) {
    var o = p.offer, v = variantFor(o.size), L = D.labels;
    var was = v ? (v.compare_c || (v.sub_c ? v.price_c : 0)) : 0, mo = v ? (v.months || 1) : 1;
    /* 2026-10-10 (Oliver): the amount charged today is the big number, struck price next to it, the per-month price under it; no per-day line */
    var tot = v ? (v.sub_c || v.price_c) : 0, forT = v ? String(mo > 1 ? D.offerPage.forN : D.offerPage.for1).replace('{price}', '').replace('{n}', mo).trim() : '';
    var price = v ? '<div class="flq-plan__price flq-plan__price--tot"><p class="flq-plan__pmrow"><span class="flq-plan__now">' + esc(money(tot)) + (forT ? '<small> ' + esc(forT) + '</small>' : '') + '</span>' + (was > tot ? '<s>' + esc(money(was)) + '</s>' : '') + '</p>' +
      '<p class="flq-plan__tot"><strong>' + esc(perMonth(v, !!v.sub_c)) + esc(D.offerPage.perMonth) + '</strong></p></div>' + (v.sub ? '<p class="flq-plan__save">' + ic('check') + esc(D.offerPage.autoship) + '</p>' : '') : '';
    return '<div class="flq-plan flq-plan--a"><div class="flq-plan__prod">' + img(I('plan_thumb') || I('plan'), 'flq-plan__thumb', 'Folliva DHT Blocker', true) + '<div><p class="flq-plan__name">' + esc(D.offerPage.product) + '</p><p class="flq-plan__size">' + esc(o.size) + (v && v.months ? ' · ' + esc(tpl(D.offerPage.supply, { n: v.months })) : '') + '</p></div></div>' +
      price + '<p class="flq-plan__why">' + esc(o.sizeWhy) + '</p>' + actions(btn(L.startPlan, 'data-flq-plan', 'flq-btn--block')) + guarLine(L.guarantee) + social() +
      (CFG.social && CFG.social.line ? '<p class="flq-socline">' + esc(CFG.social.line) + '</p>' : '') + '</div>';
  }
  function vOffer() {
    var a = s.a, p = P(), L = D.labels, direct = s.entry === 'profile_link' && !s.done;
    if (p.key === 'notnow') return vHold(p, direct);
    var o = p.offer, v = variantFor(o.size);
    /* ad links (?p=): the 'Your hair profile' card only if switched on in Customize (Links); off = the page opens on 'Sound familiar?' (Oliver 10-07) */
    var top = direct && CFG.direct_card ? profileCard(p) : '';
    var dcta = direct ? '<p class="flq-direct__cta flq-direct__cta--q">' + esc(L.notYou || 'Not quite your situation?') + ' <button type="button" class="flq-link flq-link--strong" data-flq-restart>' + esc(L.personaliseShort || L.personalise) + ' →</button></p>' : '';
    var OP = D.offerPage;
    var chipT = direct ? OP.chips.slice(0, 3) : [patternLabel(a), tpl(OP.stage, { stage: L.stages[stageIdx(a)] }), (L.goalShort || {})[a.goal] || OP.chips[0]];
    var pain = dcta;
    if (direct && p.inter) {
      var ip = String(p.inter).split(' || ');
      var ht = top ? 'h2' : 'h1';
      pain = '<section class="flq-sec flq-pain"><p class="flq-eyebrow">' + esc(L.painEyebrow || 'Sound familiar?') + '</p><' + ht + ' class="flq-title">' + hl(ip[0]) + '</' + ht + '>' +
        ip.slice(1).map(function (t) { return '<p class="flq-sub">' + gl(hl(t)) + '</p>'; }).join('') +
        (p.gap ? '<p class="flq-paingap"><span>' + esc(L.gap) + '</span>' + esc(p.gap) + '</p>' : '') + dcta + '</section>';
    }
    var chips = '<div class="flq-chips flq-chips--a">' + chipT.filter(Boolean).map(function (t) { return '<span class="flq-chip">' + esc(t) + '</span>'; }).join('') + '</div>';
    var hero = '<section class="flq-hero flq-hero--a"><figure class="flq-hero__img">' + img(I('plan'), '', 'Folliva DHT Blocker', true) + '</figure>' +
      '<div class="flq-hero__txt"><p class="flq-eyebrow">' + esc(L.recommended) + ' · ' + esc(p.name) + '</p><h2 class="flq-title flq-title--xl">' + hl(o.h) + '</h2><p class="flq-sub">' + gl(esc(o.sub)) + '</p>' + chips + planCard(p) + '</div></section>';
    var trust = '<ul class="flq-trustlist">' + ['shield', 'pause', 'truck'].map(function (icn, i) { return OP.trust[i] ? '<li>' + ic(icn) + esc(OP.trust[i]) + '</li>' : ''; }).join('') + '</ul>';
    var reasons = '<section class="flq-sec"><h3 class="flq-sec__h">' + hl(L.whyFits) + '</h3><div class="flq-calls flq-calls--3">' + p.reasons.map(function (r) {
      return '<div class="flq-call flq-reason"><h3>' + esc(r.h) + '</h3><p>' + gl(esc(r.t)) + '</p></div>';
    }).join('') + '</div></section>';
    var mid = (direct ? '<section class="flq-sec">' + vMech(p, true) + '</section>' : '') + '<section class="flq-sec">' + vProof(p, true) + '</section>';
    var how = '<section class="flq-sec flq-how">' + (I('howto') ? '<figure class="flq-how__img">' + img(I('howto'), '', 'Spraying Folliva DHT Blocker on the scalp') + '</figure>' : '') +
      '<div><h3 class="flq-sec__h">' + hl(L.howTo) + '</h3><ol class="flq-steps flq-steps--n">' + D.howTo.map(function (t) { return '<li><span>' + esc(t) + '</span></li>'; }).join('') + '</ol>' +
      (p.note ? '<p class="flq-callout">' + esc(p.note) + '</p>' : '') + '</div></section>';
    var time = '<section class="flq-sec"><h3 class="flq-sec__h">' + hl(L.expect) + '</h3><ol class="flq-journey" data-flq-journey>' + D.timeline.map(function (t, i) {
      return '<li class="flq-jstep" data-i="' + i + '"><span class="flq-jdot" aria-hidden="true">' + ic('check') + '</span><div class="flq-jcard">' +
        '<p class="flq-jk">' + esc(t.t) + '</p><h4 class="flq-jh">' + esc(t.h || '') + '</h4><p class="flq-jd">' + esc(t.d) + '</p></div></li>';
    }).join('') + '</ol></section>';
    var band = '<section class="flq-band"><div><p class="flq-band__k">' + esc(L.planEyebrow) + '</p><p class="flq-band__v">' + esc(OP.product) + ' · ' + esc(o.size) + '</p></div>' + btn(L.startPlan, 'data-flq-plan', 'flq-btn--light') + '</section>';
    var sticky = '<div class="flq-stickycta" data-flq-sticky>' + btn(L.startPlan + (v ? ' · ' + (v.sub || v.price) : ''), 'data-flq-plan', 'flq-btn--block') + '</div>';
    return top + pain + hero + trust + reasons + mid + how + time + band + sticky;
  }

  /* 2026-10-16 (Oliver): Free Starter Kit row under the plan cards, like the product page. The gifts it shows for the picked
     size are the ones checkout adds (the cart drawer's Free Starter Kit config, fc-kit-gifts.js) */
  function kitGifts(size) {
    var el = document.querySelector('script[data-fc-kit-gifts]'), cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return []; }
    size = String(size || '').trim().toLowerCase();
    return (cfg.gifts || []).map(function (g, i) { return { i: i, sizes: (g.sizes || []).map(function (x) { return String(x).trim().toLowerCase(); }) }; })
      .filter(function (g) { return g.sizes.indexOf(size) > -1; });
  }
  function kitRow() {
    var Pl = D.plan;
    if (!Pl.kitOn || Pl.kitOn === 'false' || !document.querySelector('script[data-fc-kit-gifts]')) return '';
    return '<div class="flq-kit" data-flq-kit hidden><span class="flq-kit__ths" data-flq-kit-ths aria-hidden="true"></span>' +
      '<span class="flq-kit__t"><b>' + esc(Pl.kitTitle) + '</b><span data-flq-kit-txt></span></span>' +
      '<span class="flq-kit__pr"><s data-flq-kit-was></s><i>' + esc(Pl.kitFree) + '</i></span></div>';
  }
  function kitSync(size) {
    var Pl = D.plan, box = root.querySelector('[data-flq-kit]');
    if (!box) return;
    var g = kitGifts(size), imgs = [Pl.kitImg1, Pl.kitImg2];
    box.hidden = !g.length;
    if (!g.length) return;
    box.querySelector('[data-flq-kit-ths]').innerHTML = g.map(function (x) { return imgs[x.i] ? '<span><img src="' + esc(imgs[x.i]) + '" alt="" width="40" height="40"></span>' : ''; }).join('');
    box.querySelector('[data-flq-kit-txt]').textContent = g.length > 1 ? Pl.kitText2 : Pl.kitText1;
    box.querySelector('[data-flq-kit-was]').textContent = g.length > 1 ? Pl.kitWas2 : Pl.kitWas1;
  }
  /* plan: pick the length, autoship or one-time, then straight to checkout */
  function vPlan() {
    var p = P(), Pl = D.plan, L = D.labels, rec = (p.offer && p.offer.size) || '100 ml';
    var vs = (CFG.variants || []).filter(function (v) { return v.available !== false && v.id; }).slice().sort(function (x, y) { return (y.months || 0) - (x.months || 0); });
    var auto = s.planAuto !== false, pick = s.planSize && variantFor(s.planSize) ? s.planSize : rec;
    var cards = vs.map(function (v) {
      var m = v.months || 1, on = v.title === pick;
      var badge = v.title === rec ? '<span class="flq-pc__badge">' + esc(L.recommended) + '</span>' : (m === 3 ? '<span class="flq-pc__badge flq-pc__badge--q">' + esc(Pl.best) + '</span>' : '');
      return '<label class="flq-opt flq-pc' + (on ? ' is-on' : '') + '"><input type="radio" name="flq-plan" value="' + esc(v.title) + '"' + (on ? ' checked' : '') + '>' +
        '<span class="flq-opt__ring" aria-hidden="true"></span><span class="flq-pc__dot" aria-hidden="true"></span>' +
        '<span class="flq-pc__main"><span class="flq-pc__top"><b>' + esc(tpl(m > 1 ? Pl.cardN : Pl.card1, { n: m })) + '</b><span class="flq-pc__size">' + esc(v.title) + '</span>' + badge + '</span>' +
        ((Pl.reach || {})[v.title] ? '<span class="flq-pc__reach">' + esc(Pl.reach[v.title]) + '</span>' : '') + '</span>' +
        '<span class="flq-pc__price flq-pc__price--tot"><span class="flq-pc__l1"><b data-tot></b><s data-pwas></s></span><span class="flq-pc__l2"><strong data-pm>' + esc(perMonth(v, auto)) + '</strong><span>' + esc(Pl.perMonth) + '</span></span><em data-save></em></span></label>';
    }).join('');
    var canAuto = vs.some(function (v) { return v.plan && v.sub_c; });
    var mode = canAuto ? '<label class="flq-check flq-autochk"><input type="checkbox" name="flq-auto"' + (auto ? ' checked' : '') + '><span class="flq-check__box" aria-hidden="true"></span>' +
      '<span class="flq-autochk__t"><b>' + esc(Pl.autoship) + '</b><small data-auto-note></small></span><i class="flq-autochk__chip" data-auto-off></i></label>' : '';
    var sum = '<div class="flq-psum"><span>' + esc(Pl.today) + '</span><span class="flq-psum__v"><b data-flq-today></b><s data-flq-was></s><i class="flq-pmline" data-flq-pm></i></span></div>';
    return (Pl.label ? '<p class="flq-eyebrow">' + esc(Pl.label) + '</p>' : '') + '<h1 class="flq-title">' + hl(Pl.title) + '</h1>' + (Pl.sub ? '<p class="flq-sub">' + esc(Pl.sub) + '</p>' : '') +
      mode + '<div class="flq-opts flq-pcs" role="radiogroup">' + cards + '</div>' + kitRow() + sum +
      actions('<p class="flq-due"><span>' + esc(Pl.today) + '</span><span class="flq-due__v"><b data-flq-due></b><s data-flq-was></s><i class="flq-pmline" data-flq-pm></i></span></p>' + btn(Pl.cta, 'data-flq-checkout', 'flq-btn--block') + guarLine(Pl.guarantee) + (Pl.fine ? '<p class="flq-actfine">' + ic('lock', 'flq-ic--sm') + esc(Pl.fine) + '</p>' : '') + '<p class="flq-err" data-flq-perr hidden></p>');
  }
  function planState() {
    var size = (root.querySelector('input[name="flq-plan"]:checked') || {}).value;
    var box = root.querySelector('input[name="flq-auto"]'), once = !(box && box.checked);
    var v = variantFor(size);
    return { v: v, auto: !!(v && v.plan && v.sub_c) && !once };
  }
  function bindPlan(sc) {
    var Pl = D.plan;
    function sync() {
      var c = planState(); if (!c.v) return;
      var box = root.querySelector('input[name="flq-auto"]');
      s.planSize = c.v.title; s.planAuto = box ? box.checked : true; save();
      kitSync(c.v.title);
      sc.querySelectorAll('.flq-pc').forEach(function (l) {
        var inp = l.querySelector('input'), v = variantFor(inp.value); if (!v) return;
        var auto = c.auto || (s.planAuto && v.sub_c);
        var each = auto && v.sub_c ? v.sub_c : v.price_c, ref = v.compare_c || (auto && v.sub_c ? v.price_c : 0), save_ = ref ? ref - each : 0;
        l.classList.toggle('is-on', inp.checked);
        l.querySelector('[data-pm]').textContent = perMonth(v, auto);
        var tb = l.querySelector('[data-tot]'); if (tb) tb.textContent = money(each);
        var pw = l.querySelector('[data-pwas]'); if (pw) pw.textContent = ref > each ? money(ref) : '';
        var em = l.querySelector('[data-save]'); if (em) { em.textContent = save_ > 0 ? tpl(Pl.save, { amount: money0(save_) }) : ''; em.hidden = !(save_ > 0); }
      });
      var m = c.v.months || 1, nstr = m === 1 ? Pl.every1 : tpl(Pl.everyN, { n: m });
      var an = root.querySelector('[data-auto-note]'); if (an) an.textContent = Pl.autoshipNote.replace('{n}', nstr);
      var off = root.querySelector('[data-auto-off]'); if (off) { var ref0 = c.v.compare_c || c.v.price_c, pct = c.v.sub_c && ref0 ? (1 - c.v.sub_c / ref0) * 100 : 0, prr = parseInt(root.getAttribute('data-flq-pct-round'), 10) || 1; pct = pct > 0 ? (root.getAttribute('data-flq-pct-dir') === 'nearest' ? Math.round(pct / prr) : Math.floor(pct / prr + 1e-6)) * prr : 0; /* 2026-10-11: Theme settings → Single product → Round the discount % */ var bt = Pl.badge || ''; off.textContent = bt.indexOf('{pct}') > -1 ? (pct ? bt.replace('{pct}', pct) : '') : bt; }
      var each = c.auto ? c.v.sub_c : c.v.price_c;
      var t = root.querySelector('[data-flq-today]'); if (t) t.textContent = money(each);
      root.querySelectorAll('[data-flq-due]').forEach(function (d) { d.textContent = money(each); });
      /* price per day next to "Due today" (Oliver 10-06: it moved there from the cards) */
      var pd = money(Math.round(each / (m * 30)));
      root.querySelectorAll('[data-flq-day]').forEach(function (d) { d.textContent = Pl.dueDay ? Pl.dueDay.replace('{price}', pd) : ''; });
      /* 2026-10-10 (Oliver): per-month price after the total, smaller */
      var pmT = money(Math.floor(each / m));
      root.querySelectorAll('[data-flq-pm]').forEach(function (d) { d.innerHTML = '<strong>' + esc(pmT) + '</strong>' + esc(Pl.perMonth); });
      /* the struck-through price next to "Due today": the compare-at price, same as the PDP and the cards' "Save" */
      var was = c.v.compare_c || (c.auto ? c.v.price_c : 0);
      root.querySelectorAll('[data-flq-was]').forEach(function (w) { w.textContent = was > each ? money(was) : ''; });
      var th = root.querySelector('[data-flq-then]'); if (th) th.textContent = c.auto ? tpl(Pl.then, { price: money(each), n: nstr }) : '';
    }
    sc.querySelectorAll('input[name="flq-plan"], input[name="flq-auto"]').forEach(function (i) { i.addEventListener('change', sync); });
    sync();
    sc.querySelectorAll('[data-flq-checkout]').forEach(function (b) { b.addEventListener('click', function () { checkout(b); }); });
  }
  function checkout(b) {
    var c = planState(), p = P(); if (!c.v || b.getAttribute('data-busy')) return;
    b.setAttribute('data-busy', '1'); b.classList.add('is-busy');
    log('buy_click', { step: 'offer', profile: p.code, data: { variant: String(c.v.id), plan: c.auto ? String(c.v.plan) : '', from: 'plan' } });
    var item = { id: c.v.id, quantity: 1 }; if (c.auto) item.selling_plan = c.v.plan;
    var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var fallback = function () {
      var e = root.querySelector('[data-flq-perr]'); if (e) { e.hidden = false; e.textContent = D.plan.error; }
      setTimeout(function () { location.href = (CFG.product_url || '/') + '?variant=' + c.v.id + (item.selling_plan ? '&selling_plan=' + item.selling_plan : ''); }, 600);
    };
    var ok = function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r; };
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      /* the cart ends up with exactly the plan chosen here: an earlier choice of this product (e.g. back from checkout,
         then a different plan) is replaced, the same plan is never added twice; other products are left alone */
      var ids = (CFG.variants || []).map(function (v) { return v.id; }), keep = false, updates = {}, n = 0;
      (cart.items || []).forEach(function (it) {
        if (ids.indexOf(it.variant_id) < 0) return;
        var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
        var same = it.variant_id === c.v.id && ((sp && sp.id) || null) === (item.selling_plan || null);
        if (same && !keep) { keep = true; if (it.quantity !== 1) { updates[it.key] = 1; n++; } }
        else { updates[it.key] = 0; n++; }
      });
      var first = n ? fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: updates }) }).then(ok) : Promise.resolve();
      return first.then(function () { return keep ? null : fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [item] }) }).then(ok); });
    }).then(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ attributes: { 'Quiz profile': p.code.toUpperCase(), '_quiz_id': s.id } }) });
    }).then(function () { s.attrSet = p.code; save(); return window.FCKit ? FCKit.beforeCheckout() : null; })
      .then(function () { location.href = '/checkout'; }) /* 2026-10-15: Free Starter Kit gifts go in first (fc-kit-gifts.js) */
      .catch(fallback);
  }
  /* phones: a floating "Start my plan" pill once the main button has scrolled away (never a band) */
  function stickyCta(sc) {
    var st = sc.querySelector('[data-flq-sticky]'), main = sc.querySelector('.flq-plan--a [data-flq-plan]'), band = sc.querySelector('.flq-band');
    if (!st || !main || !('IntersectionObserver' in window)) return;
    var out = false, bandIn = false;
    function upd() { st.classList.toggle('is-on', out && !bandIn); }
    new IntersectionObserver(function (es) { es.forEach(function (e) { out = !e.isIntersecting && e.boundingClientRect.top < 0; }); upd(); }).observe(main);
    if (band) new IntersectionObserver(function (es) { es.forEach(function (e) { bandIn = e.isIntersecting; }); upd(); }).observe(band);
  }
  function vHold(p, direct) {
    var H = p.hold;
    return profileCard(p) + (direct ? '' : '<blockquote class="flq-mirror">' + esc(mirror(s.a, p)) + '</blockquote>') +
      '<section class="flq-sec"><h2 class="flq-title">' + esc(H.h) + '</h2><p class="flq-lead">' + esc(H.p) + '</p><ol class="flq-steps">' + H.meanwhile.map(function (t, i) { return '<li><span class="flq-steps__ic">' + ic(['camera', 'moon', 'calendar'][i]) + '</span><span>' + esc(t) + '</span></li>'; }).join('') + '</ol></section>' +
      '<section class="flq-sec"><form class="flq-email flq-card" data-flq-remind novalidate><p class="flq-tile__k">' + esc(H.remind) + '</p>' +
      '<label class="flq-field"><span class="flq-vh">Email</span><input type="email" name="email" autocomplete="email" placeholder="' + esc(D.questions.email.placeholder) + '" required></label>' +
      '<label class="flq-check"><input type="checkbox" name="consent" required><span class="flq-check__box" aria-hidden="true"></span><span>' + esc(D.questions.email.consent) + ' <a href="' + esc(CFG.privacy_url || '/policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(D.questions.email.privacy) + '</a></span></label>' +
      '<p class="flq-err" data-flq-err hidden></p>' + actions('<button type="submit" class="flq-btn"><span>' + esc(H.remind) + '</span>' + arrow() + '</button>') + '</form>' +
      '<p class="flq-fine"><a href="' + esc(CFG.contact_url || '/pages/contact') + '">' + esc(H.contact) + ' →</a></p></section>';
  }
  function vEnd(kind) {
    var E = D.ends[kind] || D.ends.minor;
    return '<div class="flq-inter"><p class="flq-eyebrow">' + esc(E.eyebrow) + '</p><h1 class="flq-big">' + esc(E.title) + '</h1><p class="flq-lead">' + esc(E.text) + '</p></div>' +
      actions('<button type="button" class="flq-link flq-link--strong" data-flq-restart>' + esc(E.cta) + '</button>');
  }

  /* glossary: plain-language help for people who don't know the words yet */
  var GLOSS = D.gloss || {};
  function level(a) {
    if (triedFin(a) || has(a.situ, 'aas') || has(a.situ, 'trt') || has(a.situ, 'ht_done') || has(a.tried, 'device')) return 'expert';
    if (has(a.tried, 'minox') || has(a.tried, 'natural') || has(a.tried, 'supp') || ['sides_fear', 'lifelong', 'access', 'natural'].indexOf(a.whynot) > -1) return 'aware';
    return 'new';
  }
  var glossUsed = {};
  function gl(html) {
    if (level(s.a) === 'expert') return html;
    Object.keys(GLOSS).forEach(function (term) {
      if (glossUsed[term]) return;
      var re = new RegExp('(^|[^\\w>-])(' + term.replace(/[-]/g, '\\-') + ')(?![\\w-])', 'i');
      if (re.test(html) && !/<[^>]*$/.test(html.split(re)[0] || '')) {
        html = html.replace(re, function (m, pre, word) { glossUsed[term] = true; return pre + '<span class="flq-term" tabindex="0" data-def="' + esc(GLOSS[term]) + '">' + word + '</span>'; });
      }
    });
    return html;
  }
  function glossCard(p) {
    if (level(s.a) === 'expert') return '';
    var txt = JSON.stringify(p.mech || '') + ' ' + JSON.stringify(p.inter || '');
    var items = Object.keys(GLOSS).filter(function (t) { return new RegExp(t, 'i').test(txt); }).slice(0, 4);
    if (!items.length) return '';
    return '<aside class="flq-gloss"><p class="flq-why__h">' + ic('dot', 'flq-ic--xs') + esc(D.labels.glossH) + '</p><dl>' + items.map(function (t) { return '<div><dt>' + esc(t) + '</dt><dd>' + esc(GLOSS[t]) + '</dd></div>'; }).join('') + '</dl></aside>';
  }


  /* after-offer: FAQ + retake (rendered into the section placed after the buy block) */
  function afterOffer() {
    var p = P();
    if (!afterEl) return;
    var faq = (p.faq || []).map(function (f) { return '<details class="flq-faq__i"><summary>' + esc(f.q) + '</summary><p>' + esc(f.a) + '</p></details>'; }).join('');
    afterEl.innerHTML = (faq ? '<div class="flq-faq"><p class="flq-eyebrow">' + esc(D.labels.faq) + '</p>' + faq + '</div>' : '') +
      '<p class="flq-fine flq-fine--c"><button type="button" class="flq-link" data-flq-restart>' + esc(D.labels.retake) + '</button></p>' +
      '<p class="flq-disc">' + esc(D.labels.disclaimer) + '</p>';
    afterEl.querySelectorAll('[data-flq-restart]').forEach(function (b) { b.addEventListener('click', restart); });
    if (p.key !== 'notnow') {
      preselectSize(p.offer && p.offer.size);
      setCartAttributes(p);
    }
    if (s.offerLogged !== p.code) { s.offerLogged = p.code; save(); log('offer_view', { step: 'offer', profile: p.code }); }
  }

  /* ---------- interactions ---------- */
  function bind(step) {
    var sc = stage.firstChild; if (!sc) return;
    var q = D.questions[step];
    sc.querySelectorAll('[data-flq-start]').forEach(function (b) { b.addEventListener('click', function () { if (s.a.who === 'proxy') { delete s.a.who; save(); } /* "Start my analysis" = for me, even after the proxy link was tapped (2026-10-14) */ if (!s.started) { s.started = true; save(); log('start', { step: 'intro' }); } go(nextStep('intro')); }); });
    sc.querySelectorAll('[data-flq-next]').forEach(function (b) { b.addEventListener('click', function () { if (busy) return; go(nextStep(step)); }); });
    sc.querySelectorAll('[data-flq-proxy]').forEach(function (b) { b.addEventListener('click', function () { s.a.who = 'proxy'; if (!s.started) { s.started = true; save(); log('start', { step: 'intro' }); } go(nextStep('intro')); }); });
    sc.querySelectorAll('[data-flq-skiplink]').forEach(function (a) { a.addEventListener('click', function () { log('skip', { step: 'intro', profile: START || null }); }); });
    sc.querySelectorAll('[data-flq-restart]').forEach(function (b) { b.addEventListener('click', restart); });
    sc.querySelectorAll('[data-flq-buy]').forEach(function (b) { b.addEventListener('click', scrollToBuy); });
    sc.querySelectorAll('[data-flq-plan]').forEach(function (b) { b.addEventListener('click', function () { if (busy) return; go('plan'); }); });
    if (step === 'plan') bindPlan(sc);
    if (step === 'offer') stickyCta(sc);
    if (q && (q.type === 'single' || q.type === 'multi')) {
      var inputs = sc.querySelectorAll('input[name="flq-q"]'), vo = visibleOpts(step);
      var val = function (inp) { return (vo[+inp.value] || {}).v; };
      var chosen = false, armed = false;
      setTimeout(function () { armed = true; }, REDUCED ? 150 : 250);
      function choose(inp) {
        if (chosen) return; chosen = true;
        s.a[step] = val(inp);
        if (step === 'where' && s.a.where === 'none') { delete s.a.when; delete s.a.amount; }
        save();
        sc.querySelectorAll('.flq-opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(inp)); });
        log('answer', { step: step, data: { v: val(inp) } });
        var o = opt(step, val(inp));
        if (!(o && o.end)) { delete s.endKind; save(); }
        setTimeout(function () {
          if (s.step !== step) return;
          if (o && o.end) { s.endKind = o.end; save(); log('end', { step: step, data: { reason: o.end } }); go('end', { force: true }); }
          else go(nextStep(step), { force: true });
        }, REDUCED ? 60 : 240);
      }
      inputs.forEach(function (inp) {
        if (q.type === 'single') {
          inp.addEventListener('click', function () { if (!armed) { inp.checked = false; return; } inp.checked = true; choose(inp); });
          inp.addEventListener('keydown', function (e) {
            if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
            e.preventDefault();
            var list = Array.prototype.slice.call(inputs), i = list.indexOf(inp), d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
            list[(i + d + list.length) % list.length].focus();
          });
          inp.closest('.flq-opt').addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.checked = true; choose(inp); } });
          return;
        }
        inp.addEventListener('change', function () {
          if (!armed) { inp.checked = !inp.checked; return; }
          {
            if (inp.checked && inp.hasAttribute('data-exclusive')) inputs.forEach(function (o2) { if (o2 !== inp) o2.checked = false; });
            if (inp.checked && !inp.hasAttribute('data-exclusive')) inputs.forEach(function (o2) { if (o2.hasAttribute('data-exclusive')) o2.checked = false; });
            var vals = Array.prototype.filter.call(inputs, function (x) { return x.checked; }).map(val);
            s.a[step] = vals; save();
            sc.querySelectorAll('.flq-opt').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
            var nb = root.querySelector('[data-flq-multi-next]'); if (nb) nb.disabled = !vals.length;
          }
        });
      });
      var mn = sc.querySelector('[data-flq-multi-next]');
      if (mn) mn.addEventListener('click', function () {
        var v = s.a[step] || []; if (!v.length || busy || mn.getAttribute('data-done')) return;
        mn.setAttribute('data-done', '1');
        if (step === 'tried' && !triedFin(s.a)) { delete s.a.fin; delete s.a.sides; }
        if (step === 'tried' && triedFin(s.a)) { delete s.a.whynot; }
        log('answer', { step: step, data: { v: v } });
        go(nextStep(step));
      });
    }
    if (q && q.type === 'text') {
      var ta = sc.querySelector('[data-flq-text]');
      sc.querySelector('[data-flq-text-next]').addEventListener('click', function () {
        var v = (ta.value || '').trim().slice(0, 600);
        s.a.story = v; save();
        if (v) log('answer', { step: 'story', data: { v: v } });
        go(nextStep(step));
      });
    }
    sc.querySelectorAll('[data-flq-skip]').forEach(function (b) { b.addEventListener('click', function () { if (busy || b.getAttribute('data-done')) return; b.setAttribute('data-done', '1'); log('answer', { step: step, data: { skipped: true } }); go(nextStep(step)); }); });
    var ef = sc.querySelector('[data-flq-email]'); if (ef) ef.addEventListener('submit', function (e) { e.preventDefault(); submitEmail(ef, false); });
    var rf = sc.querySelector('[data-flq-remind]'); if (rf) rf.addEventListener('submit', function (e) { e.preventDefault(); submitEmail(rf, true); });
    if (step === 'loading') runLoading(sc);
    if (step === 'mech' || step === 'offer') { bindMech(sc); if (window.FCMech) [].forEach.call(sc.querySelectorAll('[data-fcm]'), function (el) { window.FCMech.init(el); }); }
    if (step === 'offer') { journeyTick(); if (sc.querySelector('[data-flq-plan]')) { if (window.flMetaVC) window.flMetaVC(); else window.__flMetaVCWant = true; } }
    if (step === 'reveal' && s.done !== P().code) {
      var p = P();
      s.done = p.code; save();
      log('complete', { step: 'reveal', profile: p.code, data: { a: s.a, key: p.key, variant: p.variant, secs: Math.round((Date.now() - s.t0) / 1000) } });
      setCartAttributes(p);
    }
  }

  /* e-mail -> Shopify customer (tags quiz-customer + quiz-a1..a9), created server-side by a Supabase function,
     so Shopify's captcha on storefront forms can't block it. Fire-and-forget: the quiz never waits on it. */
  function syncCustomer(email, consent, p, remind) {
    try {
      if (!(CFG.sb_url && CFG.sb_key)) return;
      fetch(CFG.sb_url.replace(/\/$/, '') + '/functions/v1/quiz-customer', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', apikey: CFG.sb_key },
        body: JSON.stringify({ email: email, consent: !!consent, quiz_id: s.id, profile: p.code, profile_name: p.name, remind: !!remind })
      }).catch(function () {});
    } catch (e) {}
  }
  function submitEmail(form, remind) {
    var em = form.querySelector('input[name=email]'), cb = form.querySelector('input[name=consent]'), err = form.querySelector('[data-flq-err]');
    var v = (em.value || '').trim();
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    if (!ok || !cb.checked) { err.hidden = false; err.textContent = !ok ? D.labels.emailInvalid : D.labels.emailTick; return; }
    err.hidden = true;
    var p = P();
    log('email', { step: remind ? 'remind' : 'email', profile: p.code, data: { email: v, consent: true, consent_text: D.questions.email.consent, remind: !!remind } });
    if (!(remind && s.email)) syncCustomer(v, cb.checked, p, remind);
    s.email = true; save();
    form.innerHTML = '<p class="flq-thanks">' + esc(D.questions.email.thanks) + '</p>';
    if (!remind) setTimeout(function () { go(nextStep('email')); }, 900);
  }

  function runLoading(sc) {
    var items = sc.querySelectorAll('.flq-load__list li'), i = 0, per = REDUCED ? 250 : 1500;
    var pctEl = sc.querySelector('[data-flq-pct]'), stEl = sc.querySelector('[data-flq-status]'), total = per * items.length, t0 = null;
    var lines = D.loading.lines;
    if (pctEl) (function tickPct(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / total); pctEl.textContent = Math.round(100 * (1 - Math.pow(1 - k, 2))); if (k < 1 && s.step === 'loading') requestAnimationFrame(tickPct); })(performance.now());
    if (stEl) lines.forEach(function (l, k) { if (k) setTimeout(function () { if (s.step !== 'loading') return; stEl.classList.remove('is-in'); setTimeout(function () { stEl.textContent = l; stEl.classList.add('is-in'); }, 180); }, k * per); });
    if (stEl) requestAnimationFrame(function () { stEl.classList.add('is-in'); });
    var ring = sc.querySelector('.flq-ring__p');
    if (ring) { ring.style.transitionDuration = (per * items.length / 1000) + 's'; requestAnimationFrame(function () { ring.classList.add('is-go'); }); }
    (function tick() {
      if (i > 0) items[i - 1].classList.add('is-done');
      if (i < items.length) { items[i].classList.add('is-on'); i++; setTimeout(tick, per); }
      else { var lr = sc.querySelector('.flq-lring'); if (lr) lr.classList.add('is-ok'); setTimeout(function () { if (s.step === 'loading' && !(CFG.design_mode && s.hold)) go(nextStep('loading')); }, REDUCED ? 100 : 1000); }
    })();
  }

  function restart() {
    var keepUtm = s.utm, ref = s.ref;
    s = fresh(); s.utm = keepUtm; s.ref = ref; save();
    try { history.replaceState(history.state, '', location.pathname); } catch (e) {}
    go('intro');
  }

  function scrollToBuy() {
    var sec = document.querySelector('.shopify-section[id*="template--"][id$="__main"]');
    if (!sec) { location.href = CFG.skip_url || '/'; return; }
    var y = sec.getBoundingClientRect().top + window.pageYOffset - 10;
    window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
  }

  function preselectSize(size) {
    if (!size) return;
    var sec = document.querySelector('.shopify-section[id*="template--"][id$="__main"]');
    if (!sec) return;
    var card = sec.querySelector('.fl-vcard[data-value="' + size.replace(/"/g, '') + '"] input[type=radio]');
    if (card && !card.checked) { card.click(); }
  }

  function setCartAttributes(p, force) {
    if (!force && s.attrSet === p.code) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Quiz profile': p.code.toUpperCase(), '_quiz_id': s.id } })
      }).then(function () { s.attrSet = p.code; save(); }).catch(function () {});
    } catch (e) {}
  }


  /* mechanism: tags <-> cards, short auto tour */
  function flash(el) { if (!el) return; el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash'); setTimeout(function () { el.classList.remove('is-flash'); }, 1700); }
  function fitTags(scope) {
    (scope || document).querySelectorAll('.flq-mech3d').forEach(function (fig) {
      var fw = fig.clientWidth, fh = fig.clientHeight, pad = Math.max(6, fw * .025);
      if (!fw) return;
      fig.querySelectorAll('.flq-tag3d').forEach(function (t) {
        t.style.setProperty('--dx', '0px'); t.style.setProperty('--dy', '0px');
        var l = t.offsetLeft, tp = t.offsetTop, w = t.offsetWidth, h = t.offsetHeight, dx = 0, dy = 0;
        if (l + w > fw - pad) dx = fw - pad - (l + w);
        if (l + dx < pad) dx = pad - l;
        if (tp + h > fh - pad) dy = fh - pad - (tp + h);
        if (tp + dy < pad) dy = pad - tp;
        t.style.setProperty('--dx', Math.round(dx) + 'px'); t.style.setProperty('--dy', Math.round(dy) + 'px');
      });
    });
  }
  var fitT = 0;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(function () { fitTags(root); }, 120); });
  function bindMech(sc) {
    var tags = sc.querySelectorAll('.flq-tag3d[data-pin]'), cards = sc.querySelectorAll('.flq-pin[data-pin]');
    if (!tags.length) return;
    fitTags(sc); requestAnimationFrame(function () { fitTags(sc); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitTags(sc); });
    var touched = false;
    function pair(i, scroll) {
      var t = sc.querySelector('.flq-tag3d[data-pin="' + i + '"]'), c = sc.querySelector('.flq-pin[data-pin="' + i + '"]');
      flash(t); flash(c);
      if (scroll && c && shellOn()) {
        var r0 = c.getBoundingClientRect(), b0 = stage.getBoundingClientRect(), act = stage.querySelector('.flq-actions'), ah = act ? act.offsetHeight : 0;
        if (r0.top < b0.top + 10 || r0.bottom > b0.bottom - ah - 10) { try { stage.scrollTo({ top: stage.scrollTop + r0.top - b0.top - (b0.height - ah) / 2 + r0.height / 2, behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) {} }
      } else if (scroll && c) { var r = c.getBoundingClientRect(); if (r.top < 70 || r.bottom > innerHeight - 90) { try { window.scrollTo({ top: window.pageYOffset + r.top - innerHeight / 2 + r.height / 2, behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) {} } }
    }
    tags.forEach(function (t) { t.addEventListener('click', function () { touched = true; pair(t.getAttribute('data-pin'), true); }); });
    cards.forEach(function (c) { c.addEventListener('click', function () { touched = true; pair(c.getAttribute('data-pin'), false); }); });
    if (REDUCED) return;
    tags.forEach(function (_, i) { setTimeout(function () { if (!touched && sc.isConnected) pair(i, false); }, 1300 + i * 1500); });
  }

  /* timeline: the line follows the scroll and lights each checkpoint */
  var jt = false;
  function journeyTick() {
    if (jt) return; jt = true;
    requestAnimationFrame(function () {
      jt = false;
      var el = document.querySelector('[data-flq-journey]'); if (!el) return;
      var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = (vh * 0.72 - r.top) / Math.max(1, r.height);
      p = Math.max(0, Math.min(1, p));
      el.style.setProperty('--p', p.toFixed(3));
      var steps = el.querySelectorAll('.flq-jstep'), n = steps.length;
      steps.forEach(function (li, i) { li.classList.toggle('is-on', p >= (n > 1 ? i / (n - 1) * 0.94 : 0) + 0.02); });
    });
  }
  window.addEventListener('scroll', journeyTick, { passive: true });
  window.addEventListener('resize', journeyTick);

  /* glossary tooltips (kept inside the screen) */
  function placeTip(t) {
    if (!t || !t.getBoundingClientRect) return;
    var r = t.getBoundingClientRect(), w = Math.min(280, window.innerWidth * 0.78), c = r.left + r.width / 2;
    var minC = 12 + w / 2, maxC = window.innerWidth - 12 - w / 2;
    t.style.setProperty('--tx', (Math.max(minC, Math.min(maxC, c)) - c) + 'px');
  }
  document.addEventListener('mouseover', function (e) { var t = e.target && e.target.closest && e.target.closest('.flq-term'); if (t) placeTip(t); });
  document.addEventListener('focusin', function (e) { var t = e.target && e.target.closest && e.target.closest('.flq-term'); if (t) placeTip(t); });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.flq-term');
    document.querySelectorAll('.flq-term.is-open').forEach(function (x) { if (x !== t) x.classList.remove('is-open'); });
    if (t) { placeTip(t); t.classList.toggle('is-open'); e.preventDefault(); }
  });
  document.addEventListener('keydown', function (e) {
    var t = document.activeElement; if (t && t.classList && t.classList.contains('flq-term') && (e.key === 'Enter' || e.key === ' ')) { t.classList.toggle('is-open'); e.preventDefault(); }
  });

  /* links in the sections under the plan that used to jump to the buy box (removed on this page) open the plan step */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.fl-hr-cta a, a[href*="__main"], a.fcv__btn');
    if (!a || !document.body.classList.contains('flq-tail-on')) return;
    if (document.querySelector('.shopify-section[id$="__main"] form[action*="/cart/add"]')) return;
    e.preventDefault();
    if (!busy) go('plan');
  });

  /* buy clicks inside the product block (both the main button and the sticky bar) */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.shopify-section[id$="__main"] [data-fl-atc], .fl-satc button, .fl-satc [data-fl-sticky-add]');
    if (!t || !document.body.classList.contains('flq-tail-on')) return;
    var vid = document.querySelector('.shopify-section[id$="__main"] [data-fl-variant-id]');
    log('buy_click', { step: 'offer', profile: P().code, data: { variant: vid && vid.value } });
    setCartAttributes(P(), true); /* the profile that is actually buying wins, even if another tab changed it */
  }, true);

  /* ---------- head icons for "where" ---------- */
  function headIcon(kind) {
    var hairFull = 'M14 30c0-11 8-19 18-19s18 8 18 19';
    var shapes = {
      temples: '<path class="h" d="M17 30c0-9 6-16 15-16s15 7 15 16"/><path class="t" d="M17 30c2-7 5-9 8-9M47 30c-2-7-5-9-8-9"/>',
      crown: '<path class="h" d="' + hairFull + '"/><ellipse class="t" cx="35" cy="17" rx="7" ry="3.2"/>',
      both: '<path class="h" d="M17 30c0-9 6-16 15-16s15 7 15 16"/><path class="t" d="M17 30c2-7 5-9 8-9M47 30c-2-7-5-9-8-9"/><ellipse class="t" cx="35" cy="17" rx="6" ry="2.8"/>',
      diffuse: '<path class="h h--thin" d="' + hairFull + '"/><g class="t"><circle cx="24" cy="20" r="1.2"/><circle cx="32" cy="16" r="1.2"/><circle cx="40" cy="20" r="1.2"/><circle cx="28" cy="24" r="1.2"/><circle cx="37" cy="24" r="1.2"/></g>',
      none: '<path class="h h--full" d="' + hairFull + '"/>'
    };
    return '<svg viewBox="0 0 64 64" aria-hidden="true" class="flq-head"><path class="f" d="M18 30c0 13 6 22 14 22s14-9 14-22"/><path class="f" d="M18 33c-3 0-4 4-1 6M46 33c3 0 4 4 1 6"/><path class="n" d="M26 55c0 3-4 4-8 6M38 55c0 3 4 4 8 6"/>' + (shapes[kind] || '') + '</svg>';
  }

  /* read-only helpers for QA in the browser console */
  window.FLQ_DEBUG = { profile: profile, mirror: mirror, P: P, stageIdx: stageIdx, state: function () { return s; },
    step: function () { return s.step; },
    pick: function (step, v) { return visibleOpts(step).map(function (o) { return o.v; }).indexOf(v); } };

  /* ---------- boot ---------- */
  window.addEventListener('popstate', function (e) {
    var hs = e.state || {}, st = hs.flq || hstep((location.hash || '').slice(1));
    if (hs.sid && hs.sid !== s.id) {
      /* an entry from an earlier run (before "Retake"): stay on the current run's first screen */
      s.step = 'intro'; save(); busy = false;
      try { history.replaceState({ flq: 'intro', sid: s.id }, '', location.pathname + location.search); } catch (x) {}
      render('intro', { noFocus: true, back: true });
      return;
    }
    if (st && (ORDER.indexOf(st) > -1 || st === 'end')) {
      if (st === 'loading') { st = 'email'; try { history.replaceState({ flq: st, sid: s.id }, '', '#' + hcode(st)); } catch (x) {} }
      s.step = st; save(); busy = false; render(st, { noFocus: true, back: true });
    }
  });
  if (backBtn) backBtn.addEventListener('click', function () {
    /* first screen (or a direct plan link): back leaves the quiz, to where the visitor came from */
    if (s.step === 'intro' || (s.step === 'offer' && s.entry === 'profile_link' && !s.done)) {
      var r = document.referrer || '';
      if (r.indexOf(location.origin) === 0 && history.length > 1) history.back(); else location.href = '/';
      return;
    }
    history.back();
  });
  /* theme editor: picking a text block in the sidebar opens the screen its words are on (with sample answers) */
  if (CFG.design_mode) (function () {
    var map = {};
    try { map = JSON.parse((root.querySelector('[data-flq-blocks]') || {}).textContent || '{}') || {}; } catch (e) {}
    var STEP = { t_intro: 'intro', t_pattern: 'pattern', t_loading: 'loading', t_recap: 'recap', t_reviews: 'reviews', t_reveal: 'reveal', t_mirror: 'reveal',
      t_mech: 'mech', t_ready: 'ready', t_hands: 'hands', t_plan: 'plan', t_offer: 'offer', t_howto: 'offer', t_gloss: 'mech', t_ends: 'end', t_misc: 'tried' };
    var SAMPLE = { where: 'both', when: 'y1_3', amount: 'some', family: 'father', age: '25_34', tried: ['fin_oral', 'minox'], fin: 'sides', sides: ['libido', 'energy'], situ: ['none'], worry: 'worse', goal: 'regrow', expect: 'patient' };
    document.addEventListener('shopify:block:select', function (e) {
      var type = map[(e.detail || {}).blockId]; if (!type) return;
      var key = type.indexOf('p_') === 0 ? type.slice(2) : '', step = type.indexOf('q_') === 0 ? type.slice(2) : STEP[type];
      if (key && D.profiles[key]) { s = fresh(); s.entry = 'profile_link'; s.direct = key; s.a = JSON.parse(JSON.stringify(SAMPLE)); go('offer', { force: true }); return; }
      if (!step) return;
      if (s.entry === 'profile_link' || !s.a || !s.a.where) { var keep = s.a && s.a.where ? s.a : null; s = fresh(); s.a = keep || JSON.parse(JSON.stringify(SAMPLE)); }
      s.hold = step === 'loading';
      if (step === 'end') s.endKind = 'minor';
      busy = false;
      go(step, { force: true });
      /* how-to and timeline sit lower on the offer page: bring them into view */
      if (type === 't_howto') setTimeout(function () { var h = stage.querySelector('.flq-how'); if (h) h.scrollIntoView({ block: 'start' }); }, 700);
    });
  })();
  /* theme editor: the section is re-rendered without a page load when a setting changes; reload the preview */
  if (CFG.design_mode) document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('[data-flq-root]')) location.reload(); });

  (function boot() {
    var q = new URLSearchParams(location.search);
    var code = (q.get('p') || (CFG.design_mode && CFG.editor_preview) || '').toLowerCase();
    if (Object.prototype.hasOwnProperty.call(BY_CODE, code)) {
      /* direct profile landing page from an ad (a reload keeps the same session and doesn't count twice) */
      if (!(s.entry === 'profile_link' && s.direct === BY_CODE[code] && !s.done)) {
        var d = fresh(); d.entry = 'profile_link'; d.direct = BY_CODE[code];
        s = d; s.step = 'offer'; save();
        log('profile_view', { step: 'offer', profile: code });
      }
      try { history.replaceState({ flq: 'offer', sid: s.id }, '', location.pathname + location.search); } catch (e) {}
      render('offer');
      return;
    }
    var hash = (location.hash || '').slice(1), st = s.step;
    if (hash && st && st !== 'intro' && (ORDER.indexOf(st) > -1 || st === 'end')) {
      /* a reload mid-quiz (or coming back from the cart): continue where they were */
      if (st === 'loading' && !(CFG.design_mode && s.hold)) { st = nextStep('loading'); s.step = st; save(); }
      try { history.replaceState({ flq: st, sid: s.id }, '', location.pathname + location.search + '#' + hcode(st)); save(); } catch (e) {}
      render(st, { keepScroll: true });
    } else {
      if (s.step !== 'intro' || (s.entry === 'start_link') !== !!START) s = fresh();
      save();
      try { history.replaceState({ flq: 'intro', sid: s.id }, '', location.pathname + location.search); } catch (e) {}
      render('intro', { keepScroll: true, noFocus: true });
    }
  })();
})();
